angular.module('rings-app.directives.admin', ['usersService'])
/*
* Directive to display row in table of users
* usage: <tr ng-repeat="user in users" admin-users-table-row></tr>
*/
.directive('adminUsersTable', ['usersService','$uibModal','$filter','$rootScope'
    ,function(usersService,$uibModal,$filter,$rootScope){
  return {
    restrict: 'AE',
    templateUrl : 'pages/admin-users-table.tpl.html',
    scope : {	}, 																						// isolated scope
    controllerAs : 'AdminUsersTableCtrl',
    bindToController: true,
    controller : function ($scope){

    	// variables
    	var self = this;
    	self.onlyRingers = true;
    	self.onlyActive = true;
      self.withStations = true;
    	self.showAlert = false;
      self.doingResolve = false;
      self.scheme = $rootScope.user.rings.scheme;
      self.baseAdditionalUrl = '?scheme=' + $rootScope.user.rings.scheme;
      self.additionalUrl = '&onlyRingers=true'
      self.sortColumn="Surname";
      self.sortAscending=false;
    	// modal window
    	self.modalInstance;
    	self.search = '';
      // remainder
      self.showReminder=false;
      self.mailSubject = null;
      self.remainderMessage = "Vážení kroužkovatelé,\n"
        + 'blíží se konec kalendářního roku ' + (new Date()).getFullYear() + '. Vložte prosím všechna data za uplynulý rok do webové aplikace, zkontrolujte, zda máte zaplacené příspěvky a proveďte objednávky kroužků na příští rok.'
        + 'Pokud došlo ke změně Vašich korespondenčních údajů, upravte je prosím ve Vašem profilu, abychom Vám mohli poslat kroužky na správnou adresu\n\n'
        + 'XYZ';

    	// load data
      /*self.doingResolve = true;
    	usersService.fetchUsers(self.baseAdditionalUrl + self.additionalUrl)
		    .then(function(data){
		      self.users = data;
          self.doingResolve = false;
		    }, function(data){
          self.doingResolve = false;
		      alert("Při načítání dat došlo k chybě");
		  });*/

		  // get list of users from server
		  this.getUsers = function(){
        self.doingResolve = true;
		    usersService.fetchUsers(self.baseAdditionalUrl + self.additionalUrl)
		      .then(function(data){
            self.doingResolve = false;
		        self.users = data;
            angular.forEach(self.users, function(u) {
              u.LicenceNumber = Number(u.LicenceNumber);
            });
		      }, function(data){
            self.doingResolve = false;
		        alert("Při načítání dat došlo k chybě");
		      });
		  };

      this.getUsers();

      // get all users/only ringers from DB
      self.onlyRingersChange = function(){
        
        if (!self.onlyRingers){
          if (confirm('Načtení všech uživatelů může trval velmi dlouho a způsobit problémy s prohlížečem§')){
            self.additionalUrl = '&onlyRingers=false';
            self.getUsers();
          } else {
            self.onlyRingers = !self.onlyRingers;
            self.additionalUrl = '&onlyRingers=true';
            self.getUsers();
          }
        } else {
          self.additionalUrl = '&onlyRingers=true';
          self.getUsers();
        }
      }

      // export matrix to csv - get data
      self.exportRingers = function(){
        var filtered = $filter('filter')(self.users, { isRinger: true, isActive: true }, true);
        var results = [];
        for (var i = 0; i<filtered.length; i++){
          results[i] = {
            Licence: filtered[i]['LicenceNumber'],
            Name: filtered[i]['Name'],
            Surname: filtered[i]['Surname'],
            Birhday: $filter('amDateFormat')(filtered[i]['Birthday'],'D.M.YYYY'),
            Mail: filtered[i]['Email'],
            Phone: filtered[i]['Telephone'],
            City: filtered[i]['City'],
            Address: filtered[i]['Address'],
            Account: filtered[i]['Balance'],
            Complete: filtered[i]['Complete'],
            LicencePaid: filtered[i]['LicencePaid']
          }
        }
        return results;
      }

       // header of csv file
      self.getHeader = function(){
        return ['Licence','Jméno','Příjmení','Narozen/a',"Mail","Telefon","Město","Ulice","Účet",'Komplet za rok','Průkaz Zaplacen'];
      }

    	  // updated role and/or activity
		  this.updateRingsUser = function(user){

		    var body = {};
		    body['UID'] = user.UID;
		    body['BitMask'] = (user.isRinger ? 2 : 1);          // if the user is ringer, set bitmask to 2, otherwise to 1
		    body['Role'] = (user.isRinger ? 'user' : 'public'); // if the user is ringer, set title to user, otherwise to public
		    body['RingerActive'] = user.isActive                // if the user is active, set activity to 1, otherwise to 0

		    usersService.updateRingsUser(body).then(
		    function(data) {
		      if (typeof data.error !== 'undefined') {      // error
		        alert("Při ukládání dat došlo k chybě");
		        self.getUsers();
		      } else {                                    //  OK
		      	self.showAlert = true;
		        //alert("Data byla úspěšně uložena");
		      }
		      
		    });
		  },

      self.sendReminderMail = function(){
        var filtered = $filter('filter')(self.users, { isRinger: true, isActive: true }, true);
        var filterSearch = $filter('filter')(filtered, self.search);
        var filterStations = filterSearch.filter(self.filterStations(self.withStations));
        var emails = filterStations.map(function(x){return x.Email});
        var dataToSend = {
          subject: self.mailSubject,
          content: self.remainderMessage,
          recipients: emails,
          scheme: self.scheme
        }

        usersService.sendEmail(dataToSend).then(
          function(data) {
            if (typeof data.error !== 'undefined') {      // error
              alert("Při ukládání dat došlo k chybě");
            } else {                                    //  OK
              self.showAlert = true;
            }
            
          });
      }

		  // change role of user
		  this.changeRole = function(user){
		    if (confirm("Opravdu chcete změnit roli uživatele?")) {
		      // when the role is assigned, the user is automaticaly set to active
		      if (user.isRinger){
		        user.isActive = true;
		      // when the role is removed, the user is automaticaly set to inactive
		      } else {
		        user.isActive = false;
		      }
		      this.updateRingsUser(user);
		    } else {
		      user.isRinger = !user.isRinger;
		    }
		  },

		  // change activity of user
		  this.changeActivity = function(user){
		    if (confirm("Opravdu chcete změnit aktivitu uživatele?")) {
		      user.isActive = !user.isActive;
		      this.updateRingsUser(user);
		    }
		  },

		  // open modal window with user detail
		  this.openDetail = function(user){
		  	self.editedUser = user;

		    var modalScope = $scope.$new();
		    
		    self.modalInstance = $uibModal.open({
		      template: '<admin-users-modal-window user="AdminUsersTableCtrl.editedUser" instance="AdminUsersTableCtrl.modalInstance"></admin-users-modal-window>',
		      size: 'lg',
		      scope: modalScope
		    });
		  }

		  // filter all/only ringers
		  /*this.filterRingers = function(onlyRingers) {
		    return function(user) {
		      return user.isRinger >= onlyRingers;
		    };
		  }*/

		  // filter all/only ringers
		  this.filterActive = function(onlyActive) {
		    return function(user) {
		      return user.isActive >= onlyActive;
		    };
		  }

      // filter all/only ringers
      this.filterStations = function(withStations) {
        return function(user) {
          if (withStations) {
            return true;
          } else {
            return user.bitMask !== 8;
          }
          
        };
      }
    }
  }
}])
/*user detail modal window*/
.directive('adminUsersModalWindow',['$rootScope','$filter','usersService','codebookService'
  ,function($rootScope,$filter,usersService,codebookService){
	return {
		restrict : 'E',
		templateUrl : 'templates/user-modal.tpl.html',
		scope : { 
    	user : '=',
    	instance : "="
    },
		controllerAs : 'ModalInstanceCtrl',
		bindToController: true,
    controller : function ($scope){
    	var self = this;
    	self.year = 2025;//new Date().getFullYear();
    	self.showAccount = false;
      self.doingResolve = false;
      self.doingResolveAccount = false;
    	self.accountMovements = [];
    	self.currentAccountMovement = new AccountMovement();

      codebookService.fetchOkresy($rootScope.user.rings.scheme.substring(0,2))
        .then(function(data){
          self.okresy = data;
        }, function(data){
          alert("Při načítání dat došlo k chybě");
      });

      // generic function to sum values in array of objects
      self.sum = function(arr,val){
        return arr.reduce( function(a, b){
          return a + b[val];
        }, 0);
      }

      // retrieve next licence number
      self.getLicenceNumber = function() {
        usersService.getLicenceNumber()
          .then(function(data){
            self.user.LicenceNumber = data[0].nr;
          })
      };

    	// set current account movement for editing
    	self.editAccountMovement = function(am){
        am.DateProcessed = new Date(am.DateProcessed);
    		self.currentAccountMovement = am;
    	}

    	// insert or update account movement
    	self.updateAccountMovement = function(){
    		// create body
    		var body = {
    			UID: self.user.UID,
          Year: self.currentAccountMovement.Year,
          DateProcessed: self.currentAccountMovement.DateProcessed,
    			Amount: self.currentAccountMovement.Amount,
    			Subject: self.currentAccountMovement.Subject,
    			Description: self.currentAccountMovement.Description
    		}
    		// include ID only for PUT request
    		if (self.currentAccountMovement.ID !== null){
    			body.ID = self.currentAccountMovement.ID
    		}
        self.doingResolve = true;
    		// update data on server
    		usersService.updateAccountMovement(body).then(
 					function(data) {
            if (typeof data.error !== 'undefined') {       // error
              alert($filter('translate')("SAVE.ERROR"));
              self.doingResolve = false;
            } else {   
            	var additionalUrl = '?where=UID is '+ self.user.UID;       
            	// OK - reload list of account movements from server
              usersService.fetchAccountMovements(additionalUrl).then(
			    			function(data){
			    				self.accountMovements = data;
			    				self.currentAccountMovement = new AccountMovement();
                  self.doingResolve = false;
			    			});
            } 
          });

    	}

    	// delete account movement
    	self.deleteAccountMovement = function(id){
    		if (confirm('Opravdu chcete smazat danou účetní operaci? Smazáním se změní stav účtu kroužkovatele.')){
    			self.doingResolve = true;
          var additionalUrl = '?id='+id;
	    		// update data on server
	    		usersService.deleteAccountMovement(additionalUrl).then(
	 					function(data) {
	            if (typeof data.error !== 'undefined') {       // error
	              alert($filter('translate')("SAVE.ERROR"));
                self.doingResolve = false;
	            } else {   
	            	var additionalUrl = '?where=UID is '+ self.user.UID;       
	            	// OK - reload list of account movements from server
	              usersService.fetchAccountMovements(additionalUrl).then(
				    			function(data){
				    				self.accountMovements = data;
				    				self.currentAccountMovement = new AccountMovement();
                    self.doingResolve = false;
				    			});
	            } 
	          });
    		}    		
    	}

    	// update Licence for current year
    	self.PayLicence = function(){
    		var body = {
    			UID: self.user.UID,
    			LicencePaid: self.year
    		}
        self.doingResolve = true;
    		usersService.updateRingsUser(body).then(
          function(data) {
            if (typeof data.error !== 'undefined') {       // error
              alert($filter('translate')("SAVE.ERROR"));
              self.doingResolve = false;
            } else {                                     //  OK
              // update rootUser
              //self.user.LicencePaid = self.year;
              //self.user.Balance = self.user.Balance - 500;
              //$rootScope.user = self.user;

              // update Local Storage
              //localStorage.setItem('userInfo', $rootScope.user);
              self.ShowAccount();
              self.doingResolve = false;
              alert('Licence zaplacena');
            }
          });
    	}

    	self.ShowAccount = function(){
        self.doingResolveAccount = true;
    		var additionalUrl = '?where=UID is '+ self.user.UID;
    		usersService.fetchAccountMovements(additionalUrl).then(
    			function(data){
            self.doingResolveAccount = false;
    				self.accountMovements = data;
    				self.showAccount = true;
    			});    		
    	}

		  self.ok = function(){
        self.doingResolve = true;
		  	// save data
		  	var body = {};
		    body['UID'] = self.user.UID;  
        body['Name'] = self.user.Name;
        body['Surname'] = self.user.Surname;  
		    body['LicenceNumber'] = self.user.LicenceNumber;
		    body['Address'] = self.user.Address;
		    body['City'] = self.user.City;
		    body['Title'] = self.user.Title;
    		body['Email'] = self.user.Email;
    		body['Telephone'] = self.user.Telephone;
   			body['Postcode'] = self.user.Postcode;
        body['Complete'] = self.user.Complete;
   			body['DateUpd'] = 'CURRENT_TIMESTAMP';
   			body['Note'] = self.user.Note;
        body['ID_Okres'] = self.user.idOkres;

   			usersService.updateUser(body).then(
    		  function(data) {
    		    if (typeof data.error !== 'undefined') {    	 // error
    		      alert($filter('translate')("SAVE.ERROR"));
              self.doingResolve = false;
    		    } else {
              // if ringer changes information, change also project specific data
              usersService.updateRingsUser(body).then(
                function(data2) {
                  if (typeof data.error !== 'undefined') {       // error
                    alert($filter('translate')("SAVE.ERROR"));
                    self.doingResolve = false;
                  } else {                                     //  OK
                    self.doingResolve = false;
                  	self.instance.close();
                  } 
              });              
    		    } 
    		  });

		  }

		  self.cancel = function(){
		  	self.instance.close();
		  }

    }  

	}
}])
/*
* Directive to display form to insert rings into stock
*/
.directive('insertRingordersForm', ['ringsService','$rootScope','$window','$timeout'
            ,function(ringsService,$rootScope,$window,$timeout){
  return {
    restrict: 'AE',
    templateUrl : 'pages/insert-ringorders-form.tpl.html',
    scope : { 
    	orderMade : '=',
    	action : '='
    },																				// isolated scope
    controllerAs : 'InsertRingorderFormCtrl',
    bindToController: true,
    controller : function ($scope){

    	// variables
    	var self = this;
    	self.ringOrder = new RingOrder();
      self.doingResolve = false;
      self.showAlert = false;

    	if (!$scope.ringTypes){
    		// load ringtypes
	    	ringsService.fetchRingTypes(true, $rootScope.user.rings.scheme)
		      .then(function(data){
		        self.ringTypes = data;
		      }, function(data){
		        alert(data);
		      });
    	}

    	// validate order on Admin side - when inserting rings into DB
	    this.validateInsertRings = function(ringOrder) {
	        if (!ringOrder.RingType.Code || !ringOrder.RingType.Maxvalue || !ringOrder.FromValue || !ringOrder.ToValue) { 
	            return false;
	        } else if (!isInt(ringOrder.FromValue) || !isInt(ringOrder.ToValue)) {
	            ringOrder.errorText = "Hodnoty OD a DO musí být čísla";
	            return true;
	        } else if (parseInt(ringOrder.FromValue) <= 0) {
	            ringOrder.errorText = "Hodnota OD musí být větší než 0";
	            return true;
	        } else if (parseInt(ringOrder.ToValue) < parseInt(ringOrder.FromValue)) {
	            ringOrder.errorText = "Hodnota OD musí být menší než hodnota DO";
	            return true;
	        } else if (parseInt(ringOrder.ToValue) > parseInt(ringOrder.RingType.MaxValue)) {
	            ringOrder.errorText = "Hodnota DO je větší nez nejvyšší povolená hodnota pro danou sérii";
	            return true;
	        } else {
	            ringOrder.errorText = null;
	            return false;
	        }
	    }

      this.processResults = function(value){
        switch (value) {
          case "OK":
            self.ringOrder = new RingOrder();
            self.orderMade = !self.orderMade;                 // change madeOrder identifier
            ringsService.updateNRingOrders();
            self.showAlert = true;
            break;
          case "ERROR_TO_LOWER_THAN_FROM":
            alert("Hodnota OD musí být menší než hodnota DO");
            break;
          case "ERROR_OUT_OF_RANGE":
            alert("Hodnoty OD a DO jsou mimo přípustný interval");
            break;
          case "ERROR_ALREADY_IN_DB":
            alert("Zadané kroužky jsou ve skladu Kroužkovací stanice");
            break;
          case "ERROR_RING_NOT_IN_DB":
            alert("Zadané kroužky nejsou na skladu");
            break;
          case "ERROR_ANOTHER_USER_HAS":
            alert("Zadané kroužky jsou již registrované jinému uživateli");
            break;
          case "ERROR_ALREADY_MINE":
            alert("Zadané kroužky již byly použity v evidenci, nebo jste si je již registroval/a");
            break;
          default:
            alert("Neznámá chyba, obraťte se na administrátora aplikace");
            break;
        }
      }

    	// register already owned rings
		  this.insertRings = function() {

				// validate
		  	var invalid = self.validateInsertRings(self.ringOrder);

		    if (invalid) {
		      alert("Formulář není správně vyplněn");
		      return;
		    } else {
		      var userId = $rootScope.user.UID;
		      var dataToSend = {"ID_RingType": self.ringOrder.RingType,
		                        "FromValue": self.ringOrder.FromValue,
		                        "ToValue": self.ringOrder.ToValue,
		                        "ID_UserProcessed": userId,
                            "Forced": 0,
		                        "action":self.action};
          self.doingResolve = true;
		      var result = ringsService.editRingOrder(dataToSend).then(
		        function(result) {
              self.processResults(result.returnValue);
              var element = $window.document.getElementById("ringtype");
                $timeout(function() {
                  element.focus();
                }); 
              self.doingResolve = false;
		        }
		      );
		    }
		  }
    }
  }
}])
/*
* Directive to display table of rings on stock
*/
.directive('stockRingsTable', ['ringsService',function(ringsService){
  return {
    restrict: 'AE',
    templateUrl : 'pages/stock-rings-table.tpl.html',
    scope : {
    	orderMade : '=',
      ringTypes : '=',
      updateRingtype : '='
    }, 																						// isolated scope
    controllerAs : 'StockRingsTableCtrl',
    bindToController: true,
    controller : function ($scope){

    	// variables
    	var self = this;
      self.search = {
        Code: ''
      };

      self.updateRingType = function(rt){
        var index = self.ringTypes.map(function(el) {
            return el.ID;
          }).indexOf(rt.ID);
        self.ringTypes[[index]].doingResolve = true;
        ringsService.fetchRingsOverview(rt.ID).then(function(data){
          self.ringTypes[[index]].ringsOverview = data;
          self.ringTypes[[index]].doingResolve = false;
        });
      }

      // number of remaining rings
      this.remaining = function(ring){
        if (ring.status == 1){
          return ring.max - ring.min + 1;
        } else {
          return null;
        }       
      }

      $scope.$watch("StockRingsTableCtrl.updateRingtype", function(newValue, oldValue){
        if (newValue) {
          var ids = newValue.split(',');
          angular.forEach(ids, function(id){
            var rt = self.ringTypes.filter(function(el) {
              return el.ID === Number(id);
            });
            if (rt) {
              self.updateRingType(rt[0]);
            }
          })
          
        }
      }, true);
    }
  }
}])
/*
* Directive to display list of ringorders for admin
*/
.directive('stockRingorderList', ['ringsService','usersService','$rootScope','$filter','$uibModal','$location','$timeout'
  ,function(ringsService,usersService,$rootScope,$filter,$uibModal,$location,$timeout){
  return {
    restrict: 'AE',
    templateUrl : 'pages/stock-ringorder-list.tpl.html',
    scope : {
    	orderMade : '=',
    	ringTypes : '=',
      updateRingtype : '='
    }, 																						// isolated scope
    controllerAs : 'StockRingorderListCtrl',
    bindToController: true,
    controller : function ($scope){

    	// variables
    	var self = this;
    	self.onlyAvailableRings = false;
      self.modalInstance;
      self.printedOrder = null;
    	// loading icon
    	self.doingResolve = true;

    	// load data
    	ringsService.fetchRingOrders('where=ID_Status < 3 and ID_RingingScheme is \'' + $rootScope.user.rings.scheme + '\' &withItems=true')
      .then(function(data){
      	self.doingResolve = false;
        self.ringorders = data;
      }, function(data){
        alert(data);
      });

      this.totalPrice = function(ringOrder){
        if (ringOrder == null) {return;}
        if (typeof self.ringTypes !== 'undefined'){
          var total = 0;
          for (var i = 0; i < ringOrder.ringOrderItems.length; i++){
            if (ringOrder.ringOrderItems[i].ToValue == null 
              || ringOrder.ringOrderItems[i].FromValue == null
              || ringOrder.ringOrderItems[i].ID_RingTypeAssigned == null){
              continue;
            }
            //var price = self.ringTypes.find(x=> x.Code === ringOrder.ringOrderItems[i].ID_RingTypeAssigned).Price;
            total += (ringOrder.ringOrderItems[i].ToValue - ringOrder.ringOrderItems[i].FromValue + 1)
              * ringOrder.ringOrderItems[i].PriceAssigned - (ringOrder.ringOrderItems[i].Discount ? ringOrder.ringOrderItems[i].Discount : 0);
          }
          return total;
        }      	
      }

       this.totalPriceOrdered = function(ringOrder){
        if (ringOrder == null) {return;}
        if (typeof self.ringTypes !== 'undefined'){
          var total = 0;
          for (var i = 0; i < ringOrder.ringOrderItems.length; i++){
            if (ringOrder.ringOrderItems[i].ID_RingTypeOrdered == null){
              continue;
            }
            total += ringOrder.ringOrderItems[i].Amount * ringOrder.ringOrderItems[i].PriceOrdered - (ringOrder.ringOrderItems[i].Discount ? ringOrder.ringOrderItems[i].Discount : 0);
          }
          return total;
        }       
      }

      // set as active
      this.processOrder = function(ringOrder){
        self.currentRingOrder = ringOrder;
        $location.hash('currentRo');
        //self.updateRingtype = 99;
        let items = ringOrder.ringOrderItems.map(function(it) {
          return it.ID_RingTypeOrdered;
        }).join(',');
        self.updateRingtype = items;
      }

      this.getRingOrders = function(dispatch){
      	self.doingResolve = true;
        //
        var additionalUrl = 'where=ID_Status < 3 and ID_RingingScheme is \'' + $rootScope.user.rings.scheme + '\' &withItems=true';
        if (dispatch){
          additionalUrl = 'where=ID_Status <= 5 and ID_RingingScheme is \'' + $rootScope.user.rings.scheme + '\' &withItems=true';
        }
      	ringsService.fetchRingOrders(additionalUrl)
	      .then(function(data){
	      	self.doingResolve = false;
	        self.ringorders = data;
	      }, function(data){
	        alert(data);
	      });
      }

      this.printOrder = function(ringOrder){
        self.printedOrder = ringOrder;

        var modalScope = $scope.$new();
        
        self.modalInstance = $uibModal.open({
          template: '<admin-order-modal-window order="StockRingorderListCtrl.printedOrder" instance="StockRingorderListCtrl.modalInstance"></admin-order-modal-window>',
          size: 'lg',
          scope: modalScope
        });
      }

      // when type is selected, check, if this type is available and if the serie contains enough rings
      this.changeringOrderItem = function(ringOrderItem){
        var index = self.ringTypes.map(function(el) {
            return el.ID;
          }).indexOf(ringOrderItem.ID_RingTypeAssigned);
        if (self.ringTypes[[index]].ringsOverview && self.ringTypes[[index]].ringsOverview.length>0){
          for (var i = 0; i < self.ringTypes[[index]].ringsOverview.length; i++){
            if ((self.ringTypes[[index]].ringsOverview[i].max - self.ringTypes[[index]].ringsOverview[i].min) + 1 >= ringOrderItem.Amount){
              ringOrderItem.FromValue = self.ringTypes[[index]].ringsOverview[i].min;
              ringOrderItem.ToValue = self.ringTypes[[index]].ringsOverview[i].min + ringOrderItem.Amount - 1;
              ringOrderItem.unavailable = false;
              return;
            }
          }
        }
        ringOrderItem.FromValue = null;
        ringOrderItem.ToValue = null;
        ringOrderItem.unavailable = true;
      }

      this.updateRingOrderItem = function(ringOrderItem){
        if(ringOrderItem.FromValue && ringOrderItem.Amount){
          ringOrderItem.ToValue = parseInt(ringOrderItem.FromValue) + parseInt(ringOrderItem.Amount) -1;  
        }        
      }

      this.validateAdminOrder = function(ringOrder) {
      	// check, if all fields are set
      	for (var i=0; i < ringOrder.ringOrderItems.length; i++){
      		var item = ringOrder.ringOrderItems[i];
      		if (!isNumber(item.FromValue) || item.FromValue < 1){
      			return false;
      		} else if (!isNumber(item.ToValue) || item.ToValue < item.FromValue){
      			return false;
      		}
      	}
      	return true;
      }  

      // assign rings, but keep then on stock
		  this.assignRingOrder = function(ringOrder) {
		  	var valid = self.validateAdminOrder(ringOrder);
		  	
		  	if (!valid) {
		      alert("Formulář není správně vyplněn. Zkontrolujte, zda jsou správně vyplněny rozsahy čísel pro jednotlivé série kroužků.");
		      return;
		    } else {
		    	var userId = $rootScope.user.UID;
		      var dataToSend = {"ID": ringOrder.ID,
		                        "ID_RingOrderStatus": 2, 
		                        "ID_UserOrdered": ringOrder.ID_UserOrdered,
		                        "ID_UserProcessed": userId,
		                        "ringOrderItems": ringOrder.ringOrderItems,
		                        "action":"assign"};
		      ringsService.editRingOrder(dataToSend).then(
		  	    function(result) {
		          switch (result.returnValue) {
									case "OK":
										self.orderMade = !self.orderMade;	
		                self.getRingOrders(false);
		                //ringsService.updateNRingOrders();
										alert("Data byla úspěšně uložena");
                    self.currentRingOrder = null;
										break;
									case "ERROR_TO_LOWER_THAN_FROM":
										alert("Hodnota OD musí být menší než hodnota DO");
										break;
									case "ERROR_OUT_OF_RANGE":
										alert("Hodnoty OD a DO jsou mimo přípustný interval");
										break;
									case "ERROR_ANOTHER_USER_HAS":
										alert("Zadané kroužky jsou již registrované u jiného uživatele");
										break;
									case "ERROR_ALREADY_MINE":
										alert("Zadané kroužky jsou tomuto uživateli registrované");
										break;
		              case "ERROR_RING_NOT_IN_DB":
		                alert("Některý ze zadaných kroužků není na skladu a nemůže být proto přiřazen");
										break;
									default:
										alert("Neznámá chyba, obraťte se na administrátora aplikace");
										break;
								}
		        }
		      );
		    }
		    
		  }

      // assign rings, but keep then on stock
      this.assignRingOrderPartially = function(ringOrder) {
        
        var itemsOk = [];
        var itemsMissing = [];
        for (var i=0; i < ringOrder.ringOrderItems.length; i++){
          var item = ringOrder.ringOrderItems[i];
          if ((!isNumber(item.FromValue) || item.FromValue) < 1 
            || (!isNumber(item.ToValue) || item.ToValue < item.FromValue)){
            var newItem = {
              Amount: item.Amount,
              Discount: item.Discount,
              DiscountReason: item.DiscountReason,
              RingType: {
                ID: item.ID_RingTypeOrdered
              }
            }
            itemsMissing.push(newItem);
          }  else {
            itemsOk.push(item);
          }
        }

        if (itemsOk.length == 0){
          alert('Není přiřazena žádná série, objednávka nemůže být schválena.');
          return;
        } else if (itemsMissing.length == 0) {
          alert('Jsou přiřazeny všechny série, proveďte normální schválení.');
          return;
        }

        var userId = $rootScope.user.UID;
        var dataToSend = {"ID": ringOrder.ID,
                          "ID_RingOrderStatus": 2, 
                          "ID_UserOrdered": ringOrder.ID_UserOrdered,
                          "ID_UserProcessed": userId,
                          "ringOrderItems": itemsOk,
                          "action":"assign"};
        var result = ringsService.editRingOrder(dataToSend).then(
          function(result) {
            switch (result.returnValue) {
                case "OK":
                  self.orderMade = !self.orderMade; 
                  var dataToSend = {
                    "ringOrderItems" : itemsMissing, 
                    "ID_UserOrdered" : ringOrder.ID_UserOrdered,
                    "ID_RingingScheme" : $rootScope.user.rings.scheme,
                    "Partial" : 1
                  };

                  var result = ringsService.makeRingOrder(dataToSend).then(
                      function(result) {
                        //console.log(result);
                        if (result.id) {
                          self.getRingOrders(false);
                          self.currentRingOrder = null;
                          alert("Data byla úspěšně uložena");
                          self.orderMade = !self.orderMade;
                        } else {
                          alert("Při ukládání nové objednávky nastala chyba, částečná objednávka však byla vyřízena");
                        }
                      }
                    );
                  break;
                case "ERROR_TO_LOWER_THAN_FROM":
                  alert("Hodnota OD musí být menší než hodnota DO");
                  break;
                case "ERROR_OUT_OF_RANGE":
                  alert("Hodnoty OD a DO jsou mimo přípustný interval");
                  break;
                case "ERROR_ANOTHER_USER_HAS":
                  alert("Zadané kroužky jsou již registrované u jiného uživatele");
                  break;
                case "ERROR_ALREADY_MINE":
                  alert("Zadané kroužky jsou tomuto uživateli registrované");
                  break;
                case "ERROR_RING_NOT_IN_DB":
                  alert("Některý ze zadaných kroužků není na skladu a nemůže být proto přiřazen");
                  break;
                default:
                  alert("Neznámá chyba, obraťte se na administrátora aplikace");
                  break;
              }
            }
          );
        
      }

      // dispatch ringorder - send rings to user
      this.dispatchRingOrder = function(ringOrder) {
        var valid = self.validateAdminOrder(ringOrder);

        //} else {
          var userId = $rootScope.user.UID;
          var dataToSend = {"ID": ringOrder.ID,
                            "ID_RingOrderStatus": 4, 
                            "ID_UserOrdered": ringOrder.ID_UserOrdered,
                            "ID_UserProcessed": userId,
                            "action":"dispatch"};

          var result = ringsService.editRingOrder(dataToSend).then(
            function(result) {
              switch (result.returnValue) {

                  case "OK":
                    self.orderMade = !self.orderMade; 
                    // description of
                    var desc = '';
                    for (var i = 0; i<ringOrder.ringOrderItems.length; i++){
                      if (ringOrder.ringOrderItems[i].ID_RingTypeAssigned){
                        if (ringOrder.ringOrderItems[i].Discount){
                          desc += ';Sleva '+ringOrder.ringOrderItems[i].Discount + ' - ' + ringOrder.ringOrderItems[i].DiscountReason;
                        }
                      }                      
                    }
                    desc = desc.replace(';','');
                    // calculate price to be subtracted
                    var price = 0;
                    for (var i = 0; i < ringOrder.ringOrderItems.length; i++){
                      if (ringOrder.ringOrderItems[i].ID_RingTypeAssigned){
                        price += ringOrder.ringOrderItems[i].Amount * ringOrder.ringOrderItems[i].PriceOrdered - (ringOrder.ringOrderItems[i].Discount ? ringOrder.ringOrderItems[i].Discount : 0);
                      } 
                    }
                    var balance = {
                      UID: ringOrder.ID_UserOrdered,
                      Amount: (-1)*price,
                      Year: (new Date()).getFullYear(),
                      DateProcessed: yyyymmdd(new Date()),
                      Subject: 'Objednávka kroužků ' + ringOrder.approvedId
                    }
                    if (desc.length > 0){
                      balance['Description'] = desc;
                    }
                    usersService.updateAccountMovement(balance)
                      .then(function(data){
                        if (!data.id){
                          alert('Při ukládání účetní operace došlo k chybě, objednávka však byla vyřízena');
                        }
                      });
                    self.getRingOrders();
                    self.currentRingOrder = null;
                    alert("Data byla úspěšně uložena");
                    break;

                  default:
                    //self.getRingOrders();
                    alert("Neznámá chyba, obraťte se na administrátora aplikace");
                    break;
                }
            }
          );
        //}
        
      }

      // cancel ring order
		  this.cancelRingOrder = function(ringOrder) {
		  	
		    var userId = $rootScope.user.UID;
		    var dataToSend = {"ID": ringOrder.ID,
		                      "ID_RingOrderStatus": 2, 
		                      "ID_UserOrdered": ringOrder.ID_UserOrdered,
		                      "ID_UserProcessed": userId,
		                      "ID_Status": ringOrder.ID_Status,
		                      "ringOrderItems": ringOrder.ringOrderItems,
		                      "action":"cancel"};

		     var result = ringsService.editRingOrder(dataToSend).then(
		  	    function(result) {
		          switch (result.returnValue) {
									case "OK":
										self.orderMade = !self.orderMade;	
		                self.getRingOrders();
		                //ringsService.updateNRingOrders();
                    self.currentRingOrder = null;
										alert("Data byla úspěšně uložena");
										break;
									case "ERROR_TO_LOWER_THAN_FROM":
										alert("Hodnota OD musí být menší než hodnota DO");
										break;
									case "ERROR_OUT_OF_RANGE":
										alert("Hodnoty OD a DO jsou mimo přípustný interval");
										break;
									case "ERROR_ANOTHER_USER_HAS":
										alert("Zadané kroužky jsou již registrované u jiného uživatele");
										break;
									case "ERROR_ALREADY_MINE":
										alert("Zadané kroužky jsou tomuto uživateli registrované");
										break;
		              case "ERROR_RING_NOT_IN_DB":
		                alert("Některý ze zadaných kroužků není na skladu a nemůže být proto přiřazen");
										break;
									default:
		                //self.getRingOrders();
										alert("Neznámá chyba, obraťte se na administrátora aplikace");
										break;
								}
		        }
		      ); 
		    }
		    
		  //}
    }
  }
}])
.directive('printDiv', ['amMoment',function (amMoment) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      element.bind('click', function(evt){    
        evt.preventDefault();    
        PrintElem(attrs.printDiv);
      });

      function PrintElem(elem)
      {
        PrintWithIframe($(elem).html());
      }

      function PrintWithIframe(data) 
      {
        if ($('iframe#printf').size() == 0) {
          $('html').append('<iframe id="printf" name="printf"></iframe>');  // an iFrame is added to the html content, then your div's contents are added to it and the iFrame's content is printed

          var today = moment(new Date()).format('LL');
          var mywindow = window.frames["printf"];
          mywindow.document.write('<html><head><title>'+today+'</title><style>@page {color: red}</style>'  // Your styles here, I needed the margins set up like this
                          + '</head><body><div>'
                          + data
                          + '</div></body></html>');

          $(mywindow.document).ready(function(){
            mywindow.print();
            setTimeout(function(){
              $('iframe#printf').remove();
            },
            2000);  // The iFrame is removed 2 seconds after print() is executed, which is enough for me, but you can play around with the value
          });
        }

        return true;
      }
    }
  };
}])
/*user detail modal window*/
.directive('adminOrderModalWindow',['$rootScope','$filter','usersService','codebookService','ringsService','amMoment'
  ,function($rootScope,$filter,usersService,codebookService,ringsService,amMoment){
  return {
    restrict : 'E',
    templateUrl : 'templates/print-order-modal.tpl.html',
    scope : { 
      order : '=',
      instance : "="
    },
    controllerAs : 'PrintOrderCtrl',
    bindToController: true,
    controller : function ($scope){
      
      var self = this;
      self.today = new Date();

      this.totalPrice = function(){
        var total = 0;
        for (var i = 0; i < self.order.ringOrderItems.length; i++){
          if (self.order.ringOrderItems[i].ID_RingTypeAssigned){
            total += (self.order.ringOrderItems[i].ToValue - self.order.ringOrderItems[i].FromValue + 1)
            * self.order.ringOrderItems[i].PriceAssigned - (self.order.ringOrderItems[i].Discount ? self.order.ringOrderItems[i].Discount : 0);
          }          
        }
        return total;       
      }

      this.ringsPrice = function(){
        var total = 0;
        for (var i = 0; i < self.order.ringOrderItems.length; i++){
          if (self.order.ringOrderItems[i].ID_RingTypeAssigned){
            total += (self.order.ringOrderItems[i].ToValue - self.order.ringOrderItems[i].FromValue + 1)
            * self.order.ringOrderItems[i].PriceAssigned;
          }          
        }
        return total;       
      }

      this.discountPrice = function(){
        var total = 0;
        for (var i = 0; i < self.order.ringOrderItems.length; i++){
          if (self.order.ringOrderItems[i].ID_RingTypeAssigned){
            total += (self.order.ringOrderItems[i].Discount ? self.order.ringOrderItems[i].Discount : 0);
          }          
        }
        return total;       
      }

      // call print function with given element
      self.print = function(){

        printElement(document.getElementById("toPrint"));

        window.print();
      }

      self.saveAsPrinted = function(){
        var dataToSend = {
          ID: self.order.ID,
          Printed: 1
        }
        ringsService.editRingOrderRaw(dataToSend)
          .then(function(response){
          })
      }

      // print element
      function printElement(elem) {

        var domClone = elem.cloneNode(true);

        var $printSection = document.getElementById("toPrint");
        
        if (!$printSection) {
            var $printSection = document.createElement("div");
            $printSection.id = "toPrint";
            document.body.appendChild($printSection);
        }
        
        $printSection.innerHTML = "";
        
        $printSection.appendChild(domClone);
    }


      self.cancel = function(){
        self.instance.close();
      }

    }  

  }
}])
/*
* directive to insert observation
*/
.directive('adminSimpleInsert', ['observationService','codebookService','ringsService','locationService','$rootScope','$anchorScroll','$q','$filter','$timeout','myConfig'
  ,function(observationService,codebookService,ringsService,locationService,$rootScope,$anchorScroll,$q,$filter,$timeout,myConfig){
  return {
    restrict: 'E',
    templateUrl : 'pages/admin-simple-insert.tpl.html',
    scope : {},                                             // isolated scope
    controllerAs : 'AdminSimpleCtrl',
    bindToController: true,
    controller : function ($scope){

      // variables
      var self = this;
      // data model
      self.date = null;
      self.time = null;
      self.note = null;
      //self.owner='krouzkovaci_stanice';
      self.coobservers = null;
      self.country = ''
      self.locality = new Locality();
      self.detail = new Observation($rootScope.user.rings.scheme);
      self.scheme = $rootScope.user.rings.scheme;
      self.owner = (self.scheme === 'CZP' ? 'krouzkovaci_stanice' : 'bratislava');
      self.siblings = null;
      // helpers
      self.maxDate = new Date();
      self.datePickerOpened = false;
      self.showAlert = false;
      self.countryCode = 'CZP';

      // map options
      self.mapOption = {
        lat: 49.85,
        lng: 15.50,
        zoom: 6
      }
      
      // load codebook
      codebookService.fetchCodebook()
        .then(function(data){
          self.codebook = data;
          // set Czech republic
          for (var i = 0; i<self.codebook.placecode.length; i++){
            if (self.codebook.placecode[i].Code == 'CZ--'){
              self.country = self.codebook.placecode[i];
              self.detail.placecode = 'CZ--';
            }
          }
        }, function(data){
          alert(data);
        });

      ringsService.fetchRingTypes(true, $rootScope.user.rings.scheme)
        .then(function(data){
          self.ringTypes = data;
        }, function(data){
          alert(data);
        });

      // load locations
      var userId = $rootScope.user.UID;
      var query = "UID=" + userId;
      locationService.fetchUserLocations(query)
        .then(function(data){
          self.locations = data;
        }, function(data){
          alert(data);
        });

      // when autocompleter option for municipality is selected, update model
      this.updateMunicipality = function (selectedValue) {
        if (selectedValue) {   
          var str = selectedValue.originalObject.obec;
          self.locality.Municipality = str.substring(0,str.indexOf('['));
          self.locality.KODCOBE = selectedValue.originalObject.KODCOBE;
          self.locality.ID_MunicipalityPart = selectedValue.originalObject.ID;
          self.detail.placeCode = selectedValue.originalObject.EuringCode;
          self.locality.coords.latitude = selectedValue.originalObject.latitude;
          self.locality.coords.longitude = selectedValue.originalObject.longitude;
          self.locality.crdsText = parseFloat(self.locality.coords.latitude).toFixed(5) + ', ' + parseFloat(self.locality.coords.longitude).toFixed(5);
          self.mapOption.lat = selectedValue.originalObject.latitude;
          self.mapOption.lng = selectedValue.originalObject.longitude;
          self.mapOption.zoom = 12; 
        }
      };

      this.obceUrl = function() {
        return myConfig[self.countryCode].obceUrl
      };

      this.updateLocation = function(loc) {
        if (!loc) {
          return;
        }
        self.locality.coords = {longitude: loc.longitude, latitude: loc.latitude}
        $scope.$broadcast('angucomplete-alt:changeInput', 'select-municipality', loc.Municipality);
        self.locality.Municipality = loc.Municipality;
        self.locality.KODCOBE = loc.KODCOBE;
        self.locality.Name = loc.Name;
        self.locality.crdsText = parseFloat(self.locality.coords.latitude).toFixed(5) + ', ' + parseFloat(self.locality.coords.longitude).toFixed(5);
        // set zoom and center of map
        self.mapOption.zoom = 12;
        self.mapOption.lat = self.locality.coords.latitude;
        self.mapOption.lng = self.locality.coords.longitude;
        $timeout(function() {
          $rootScope.$broadcast('locationUpdated');
        }, 100);
      }

      // when autocompleter option for municipality is selected, update model
      this.updateRinger = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
          self.owner = (self.scheme === 'CZP' ? 'krouzkovaci_stanice' : 'bratislava');;

          return;
        }
        self.owner = selectedValue.originalObject.owner;
      };

      // when autocompleter option is selected, update model
      this.updateSpecies = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
          self.detail.species = {TaxonID: null,Name:null,Fullname:null,isWader:null};
          return;
        }
        self.detail.species = selectedValue.originalObject; 
      };

      // functions - validation
      this.validate = function(){
        // validate ObsList
        // validate date
        if (self.date == null){           // date not set
          alert($filter('translate')("DATE.NOT.SET"));
          return false;
        } else {
          var dt = new Date(self.date);   // date in incorrect format
          if ( Object.prototype.toString.call(dt) === "[object Date]" 
              && isNaN(dt.getTime())){
            alert($filter('translate')("DATE.NOT.SET"));
            return false;
          } else {
            var today = new Date();       // date in future
            if (dt > today){
              alert($filter('translate')("DATE.FUTURE"));
              return false;
            }
          }         
        }       
        // validate coordinates
        if ( self.locality.err
          || typeof self.locality.coords === 'undefined'
          || self.locality.coords == null
          || !isNumber(self.locality.coords.latitude)
          || !isNumber(self.locality.coords.longitude)){
          alert($filter('translate')("CRDS.NOT.SET"));
          return false;
        }
        // obsList OK

        // validate obsitem
        
        // serie
        if (self.detail.ringTypeObj == null || self.detail.ringTypeObj.length == 0){
          alert('Není zvolena série');
          return false;
        }
        // ring number
        if (self.detail.ringNumber1 == null || self.detail.ringNumber1.length == 0){
          alert($filter('translate')("RINGNUMBER.NOT.SET"));
          return false;
        }
        // sex
        if (self.detail.sex == null ){
          alert($filter('translate')("SEX.NOT.SET"));
          return false;
        }
        // validate species
        if ((self.detail.species == null || self.detail.species.TaxonID == null) && self.detail.ringInformation != 4){
          alert($filter('translate')("SPECIES.NOT.SET"));
          return false;
        }

        return true;
      }

      this.reset = function(all,newol){
        if (!all) {
          self.date = null;
          self.datePickerOpened = false;
          self.time = null;
          self.locality = new Locality();
          self.crdsText = null;
          self.owner = (self.scheme === 'CZP' ? 'krouzkovaci_stanice' : 'bratislava');;
          self.coobservers = null;
          self.siblings = null;
          self.detail = new Observation($rootScope.user.rings.scheme);
          $rootScope.$broadcast('angucomplete-alt:clearInput');
        } else {
          // new obslist
          if (newol) {
            self.detail.obsListId = null;
          }
          self.detail.ringNumber1 = parseInt(self.detail.ringNumber1) + 1;
        }      
        self.note = null;
        
      }

      // check ring availability
      this.leaveRn = function() {
        if (this.detail.ringNumber1 && this.detail.ringTypeObj) {
          let dataToSend = {
            serie: this.detail.ringTypeObj.Code,
            rn: this.detail.ringNumber1
          }
          observationService.checkRingAvailable(dataToSend)
            .then(function(result){
              if (result === 'false') {
                alert('Kroužkem již bylo kroužkováno');
              }
            })
        }
      }

      // save to DB
      this.saveDetail = function(repeat,newol){
        if (self.validate()){

          var dataToSend = angular.copy(self.detail);
          dataToSend['user'] = $rootScope.user;   
          dataToSend['date'] = self.date;
          dataToSend['time'] = self.time;
          dataToSend['lat'] = self.locality.coords.latitude;
          dataToSend['lon'] = self.locality.coords.longitude;
          dataToSend['coobservers'] = self.coobservers;
          dataToSend['owner'] = self.owner;
          dataToSend['sitename'] = self.locality.Name;
          dataToSend['siblings'] = self.siblings;
          dataToSend['KODCOBE'] = self.locality.KODCOBE;
          dataToSend['ID_MunicipalityPart'] = self.locality.ID_MunicipalityPart;
          if (newol) {
            self.detail.obsListId = null;
          }
          
          self.send(dataToSend)
            .then(function(result){
              if (result.error) {
                alert('Při ukládání došlo k chybě: ' + result.error);
              } else {
                self.showAlert = true;
                self.reset(repeat,newol);
                if (repeat) {
                  self.detail.obsListId = result.id;
                  $anchorScroll('#ringinfo');
                } else {
                  $anchorScroll('#obsinfo');
                }
              }
            })
        }
      }

      // send method
      this.send = function(dataToSend){
        var deferred = $q.defer();
        var result = observationService.sendSimpleAdminObservation(dataToSend).then(
          function(result) {
            deferred.resolve(result); 
          });
        return deferred.promise;
      }

    }
  }
}])
/*
* directive to insert observation
*/
.directive('adminObservation', ['observationService','codebookService','rasService','$q','$rootScope','$cookieStore','$state','$location','$anchorScroll','$filter','Upload','$timeout','myConfig'
  ,function(observationService,codebookService,rasService,$q,$rootScope,$cookieStore,$state,$location,$anchorScroll,$filter,Upload,$timeout,myConfig){
  return {
    restrict: 'E',
    templateUrl : 'pages/admin-observation.tpl.html',
    scope : {},                                             // isolated scope
    controllerAs : 'AdminObservationCtrl',
    bindToController: true,
    controller : function (){

      // variables
      var self = this;
      //self.id = null,
      self.date = null;
      self.maxDate = new Date();
      self.datePickerOpened = false;
      self.time = null;
      self.note = null;
      self.coobservers = null;
      self.locality = new Locality();
      self.scheme = $rootScope.user.rings.scheme;
      self.detail = new Observation(self.scheme);
      self.detail.ringInformation = 4; // default retrap
      self.detail.ringingScheme = self.scheme;
      self.owner = (self.detail.ringingScheme === 'CZP' ? 'krouzkovaci_stanice' : 'bratislava');
      self.showAlert = false;
      self.showCircumstancesDetail = false;
      self.obceUrl = myConfig[self.scheme].obceUrl;
      self.druhUrl = myConfig[self.scheme].druhUrl;
      

      // map options
      self.mapOption = myConfig[$rootScope.user.rings.scheme].mapOption;

      self.ringInformation = [
        {"code": 1,"description": "Kroužkování"}
        ,{"code": 4,"description": "Zpětné hlášení"}
        ,{"code": 6,"description": "Odstranění kroužku"}];

      self.supportedFormatsTpl = "Podporované formáty:<ul><li>48.255757N, 17.597398E</li><li>N 50&deg;2.96520&rsquo;, E 14&deg;30.58850&rsquo;</li><li>39º17'00''N 03º14'00''W</li><li>39 41 45N 03 14 00W</li><li>50&deg;4&rsquo;49.008&rdquo;N, 14&deg;24&rsquo;37.656&rdquo;E</li></ul>"

        // load codebook
      codebookService.fetchCodebook()
        .then(function(data){
          self.codebook = data;
          // set Czech republic/ Slovakia
          for (var i = 0; i<self.codebook.placecode.length; i++){
            var scheme = $rootScope.user.rings.scheme;
            if (scheme === 'CZP') {
              if (self.codebook.placecode[i].Code == 'CZ--'){
                self.country = self.codebook.placecode[i];
                self.detail.placecode = 'CZ--';
              }
            } else if (scheme === 'SKB') {
              if (self.codebook.placecode[i].Code == 'SK--'){
                self.country = self.codebook.placecode[i];
                self.detail.placecode = 'SK--';
              }
            }
            
          }
        }, function(data){
          alert(data);
        });

      rasService.getCesProjects('?where=ID_RingingScheme is \'' + $rootScope.user.rings.scheme + "'")
        .then(function(data){
          self.cesProjects = data;
        });

      // when circumstances are changed, check, if parent code starts with P. if not, set it as circumstances
      this.changeCircumstances = function(){
        if (typeof self.detail.circumstancesParent !== 'undefined' && self.detail.circumstancesParent.startsWith('P') != true){
          self.showCircumstancesDetail = false;
          self.detail.circumstances = self.detail.circumstancesParent;
        } else {
          self.showCircumstancesDetail = true;
        }
      }

      this.changeAge = function() {
        if (self.detail.age === 200){
          self.detail.status = '-';
        }
      };

      // when country is selected, update place code
      this.updatePlaceCode = function(){
        self.detail.placecode = self.country.Code;
      }

      // when autocompleter option for municipality is selected, update model
      this.updateMunicipality = function (selectedValue) {
        if (selectedValue) {
          var str = selectedValue.originalObject.obec;
          self.locality.Municipality = str.substring(0,str.indexOf('['));
          self.locality.KODCOBE = selectedValue.originalObject.KODCOBE;
          self.locality.ID_MunicipalityPart = selectedValue.originalObject.ID;
          self.detail.placecode = selectedValue.originalObject.EuringCode;
          self.mapOption.lat = selectedValue.originalObject.latitude;
          self.mapOption.lng = selectedValue.originalObject.longitude;
          self.mapOption.zoom = 12;
        }
      };

      // when autocompleter option for municipality is selected, update model
      this.updateRinger = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
          self.owner = ($rootScope.user.rings.scheme === 'CZP' ? 'krouzkovaci_stanice' : 'bratislava');
          return;
        }
        self.owner = selectedValue.originalObject.owner;
      };

      // parses text and retrieves coordinates from it
      this.updateCrds = function(){
        if (self.locality.crdsText == null || self.locality.crdsText == ''){
          self.locality.err = false;
          return;
        }
        // example 48.255757N, 17.597398E, 48.255757 ;17.597398
        var regexPattern1 = /^([-]?[0-9]{1,2}\.[0-9]*)[N,S]?[\s,;]+([-]?[0-9]{1,2}\.[0-9]*)[E,W]?$/i;
        // example 50°4'49.008"N, 14°24'37.656"E
        var regexPattern2 = /^([-]?[0-9]{1,2})°([0-9]{1,2})'([0-9]{1,2}\.?[0-9]+?)"[N,S]?,?\s*([-]?[0-9]{1,2})°([0-9]{1,2})'([0-9]{1,2}\.?[0-9]+?)"[E,W]?$/i;
        // example 50°4'N 14°24'E
        var regexPattern2a = /^([-]?[0-9]{1,2})°([0-9]{1,2})'[N,S]?\s*([-]?[0-9]{1,2})°([0-9]{1,2})'[E,W]?$/i;
        // example N 50°2.96520', E 14°30.58850'
        var regexPattern3 = /^[N,S] ([0-9]{1,2})°([0-9]{1,2}\.[0-9]+)', [E,W] ([0-9]{1,2})°([0-9]{1,2}\.[0-9]+)'$/i
        // example 39º17'00''N 03º14'00''W
        var regexPattern4 = /^([0-9]{1,2})º([0-9]{1,2})'([0-9]{2})''[N,S] ([0-9]{1,2})º([0-9]{1,2})'([0-9]{2})''[E,W]$/i
        // example 39 17 00N 03 14 00W
        var regexPattern5 = /^([0-9]{1,2}) ([0-9]{1,2}) ([0-9]{1,2})[N,S] ([0-9]{1,2}) ([0-9]{1,2}) ([0-9]{1,2})[E,W]$/i
        // example 47°38'50"N 18°19'8"E
        var regexPattern6 = /^([-]?[0-9]{1,2})°([0-9]{1,2})'([0-9]{1,2})"[N,S]? ([-]?[0-9]{1,2})°([0-9]{1,2})'([0-9]{1,2})"[E,W]?$/i;

        if (regexPattern1.test(self.locality.crdsText)){
          var match = regexPattern1.exec(self.locality.crdsText);
          self.locality.coords.longitude = match[2];
          if (self.locality.crdsText.indexOf('W') !== -1){
            self.locality.coords.longitude = (-1)*self.locality.coords.longitude;
          }
          self.locality.coords.latitude = match[1];
           if (self.locality.crdsText.indexOf('S') !== -1){
            self.locality.coords.latitude = (-1)*self.locality.coords.latitude;
          }
          self.locality.err = false;
        } else if (regexPattern2.test(self.locality.crdsText)){
          var match = regexPattern2.exec(self.locality.crdsText);
          degreeN = match[1];
          degreeE = match[4];
          minuteN = match[2];
          minuteE = match[5];
          secondN = match[3];
          secondE = match[6];
          var lat = parseFloat(degreeN) + parseFloat(minuteN)/60 + parseFloat(secondN)/3600;
          if (self.locality.crdsText.indexOf('S') !== -1){
            lat = (-1)*lat
          }
          var lon = parseFloat(degreeE) + parseFloat(minuteE)/60 + parseFloat(secondE)/3600;
          if (self.locality.crdsText.indexOf('W') !== -1){
            lon = (-1)*lon
          }
          self.locality.coords.longitude =lon;
          self.locality.coords.latitude = lat;
          self.locality.err = false;
        } else if (regexPattern2a.test(self.locality.crdsText)) {
          var match = regexPattern2a.exec(self.locality.crdsText);
          degreeN = match[1];
          degreeE = match[3];
          minuteN = match[2];
          minuteE = match[4];
          var lat = parseFloat(degreeN) + parseFloat(minuteN)/60;
          if (self.locality.crdsText.indexOf('S') !== -1){
            lat = (-1)*lat
          }
          var lon = parseFloat(degreeE) + parseFloat(minuteE)/60;
          if (self.locality.crdsText.indexOf('W') !== -1){
            lon = (-1)*lon
          }
          self.locality.coords.longitude =lon;
          self.locality.coords.latitude = lat;
          self.locality.err = false;
        } else if (regexPattern3.test(self.locality.crdsText)){
          var match = regexPattern3.exec(self.locality.crdsText);
          degreeN = match[1];
          degreeE = match[3];
          minuteN = match[2];
          minuteE = match[4];
          var lat = parseFloat(degreeN) + parseFloat(minuteN)/60;
          if (self.locality.crdsText.indexOf('S') !== -1){
            lat = (-1)*lat
          }
          var lon = parseFloat(degreeE) + parseFloat(minuteE)/60;
          if (self.locality.crdsText.indexOf('W') !== -1){
            lon = (-1)*lon
          }
          self.locality.coords.longitude =lon;
          self.locality.coords.latitude = lat;
          self.locality.err = false;
        } else if (regexPattern4.test(self.locality.crdsText)){
          var match = regexPattern4.exec(self.locality.crdsText);
          degreeN = match[1];
          degreeE = match[4];
          minuteN = match[2];
          minuteE = match[5];
          secondN = match[3];
          secondE = match[6];
          var lat = parseFloat(degreeN) + parseFloat(minuteN)/60 + parseFloat(secondN)/3600;
          if (self.locality.crdsText.indexOf('S') !== -1){
            lat = (-1)*lat
          }
          var lon = parseFloat(degreeE) + parseFloat(minuteE)/60 + parseFloat(secondE)/3600;
          if (self.locality.crdsText.indexOf('E') !== -1){
            lon = (-1)*lon
          }
          self.locality.coords.longitude =(-1)*lon;
          self.locality.coords.latitude = lat;
          self.locality.err = false;
        } else if (regexPattern5.test(self.locality.crdsText)){
          var match = regexPattern5.exec(self.locality.crdsText);
          degreeN = match[1];
          degreeE = match[4];
          minuteN = match[2];
          minuteE = match[5];
          secondN = match[3];
          secondE = match[6];
          var lat = parseFloat(degreeN) + parseFloat(minuteN)/60 + parseFloat(secondN)/3600;
          if (self.locality.crdsText.indexOf('S') !== -1){
            lat = (-1)*lat
          }
          var lon = parseFloat(degreeE) + parseFloat(minuteE)/60 + parseFloat(secondE)/3600;
          if (self.locality.crdsText.indexOf('E') !== -1){
            lon = (-1)*lon
          }
          self.locality.coords.longitude =(-1)*lon;
          self.locality.coords.latitude = lat;
          self.locality.err = false;
        } else if (regexPattern6.test(self.locality.crdsText)){
          var match = regexPattern6.exec(self.locality.crdsText);
          degreeN = match[1];
          degreeE = match[4];
          minuteN = match[2];
          minuteE = match[5];
          secondN = match[3];
          secondE = match[6];
          var lat = parseFloat(degreeN) + parseFloat(minuteN)/60 + parseFloat(secondN)/3600;
          if (self.locality.crdsText.indexOf('S') !== -1){
            lat = (-1)*lat
          }
          var lon = parseFloat(degreeE) + parseFloat(minuteE)/60 + parseFloat(secondE)/3600;
          if (self.locality.crdsText.indexOf('W') !== -1){
            lon = (-1)*lon
          }
          self.locality.coords.longitude =lon;
          self.locality.coords.latitude = lat;
          self.locality.err = false;
        } else {
          alert('Zadaný formát souřadnic se nepodařilo rozpoznat');
          //self.crdsError = true;
          self.locality.err = true;
        }
        if (!self.locality.err){
          self.mapOption.lng = parseFloat(self.locality.coords.latitude);
          self.mapOption.lng = parseFloat(self.locality.coords.longitude);
          self.mapOption.zoom = 12;
        }
        $timeout(function() {
          $rootScope.$broadcast('locationUpdated');
        }, 100);
      }

      // when autocompleter option is selected, update model
      this.updateSpecies = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
          self.detail.species = {TaxonID: null,Name:null,Fullname:null,isWader:null};
          return;
        }
        self.detail.species = selectedValue.originalObject; 
        self.detail.speciesUnknown = false;
      };

      this.speciesUnknown = function(){
        if (self.detail.speciesUnknown){
          $rootScope.$broadcast('angucomplete-alt:clearInput');
        }
      }

      // additional marks functions
      // after click on additional mark set delete it
      self.removeAdditionalMark = function(mark) {
        if (confirm('Opravdu chcete smazat identifikační značku?')) {
          //delete self.marks[mark.uuid];
          self.detail.additionalMarks = self.detail.additionalMarks.filter(function (el) {
            return el !== mark;
          });
        }
      }

      // return class for color - required based on markType
      this.colorRequired = function(mark){
        if(typeof mark === 'undefined'){
          return null;
        } else if (['B0','C0','D0','H0'].indexOf(mark.markType) != -1){
          return 'required';
        } else {
          return null;
        }
      }

      // add identification mark
      self.addIdentificationMark = function() {
        self.detail.additionalMarks.push(new Mark());      
      }

      // filter - return true if the species is wader, otherwise return false
      self.filterEmpty = function() {
        return function( item ) {
          return item.Name.length > 1;
        };
      };

      // upload on file select or drop
      this.uploadFile = function (file) {
        self.doingImgResolve = true;
          Upload.upload({
              //url: myConfig.apiUrl + 'rings/image',
              url: 'https://rings.birds.cz/proxy/v1/rings/image',
              data: {file: file}
          }).then(function (resp) {
            self.doingImgResolve = false;
            self.detail.photoId = resp.data.id;
            self.detail.photoName = resp.data.name;
            self.detail.photoPath = '/userdata/images/'+self.detail.photoName+'.jpg';
          }
          , function (resp) {
            alert('Při nahrávání fotografie došlo k chybě');
            self.doingImgResolve = false;
          }
          , function (evt) {
            // TODO - progress bar
            //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
          });
      };

      this.deleteFile = function(){
        self.currentDetail.photoId = null;
        alert('Pro povrzení smazání fotografie uložte záznam')
      }

      // functions - validation
      this.validate = function(){
        // validate ObsList
        // validate date
        if (self.date == null){           // date not set
          alert($filter('translate')("DATE.NOT.SET"));
          return false;
        } else {
          var dt = new Date(self.date);   // date in incorrect format
          if ( Object.prototype.toString.call(dt) === "[object Date]" 
              && isNaN(dt.getTime())){
            alert($filter('translate')("DATE.NOT.SET"));
            return false;
          } else {
            var today = new Date();       // date in future
            if (dt > today){
              alert($filter('translate')("DATE.FUTURE"));
              return false;
            }
          }         
        }
        // validate municipality
        if (self.country == null 
          ||typeof self.country === 'undefined' 
          || self.country.length == 0){
          alert($filter('translate')("COUNTRY.NOT.SET"));
          return false;
        }
        // validate coordinates
        if ( self.locality.err
          || typeof self.locality.coords === 'undefined'
          || self.locality.coords == null
          || !isNumber(self.locality.coords.latitude)
          || !isNumber(self.locality.coords.longitude)){
          alert($filter('translate')("CRDS.NOT.SET"));
          return false;
        }
        // validate CZ
        if (self.locality.Country
          && self.locality.Country!='CZ'){
          return false;
        }
        // obsList OK

        // validate obsitem
        // identification method
        if (self.detail.markType == null){
          alert($filter('translate')("MARKTYPE.NOT.SET"));
          return false;
        }
        // ring number
        if (self.detail.ringNumber1_retrap == null || self.detail.ringNumber1_retrap.length == 0){
          alert($filter('translate')("RINGNUMBER.NOT.SET"));
          return false;
        }
        // validate mark color of additional marks
        for (var i = 0; i < self.detail.additionalMarks.length; i++){
          var mark = self.detail.additionalMarks[i];
          if (['B0','C0','D0','H0'].indexOf(mark.markType) != -1
            && mark.markColor == null){
            alert($filter('translate')("MARKCOLOR.NOT.SET"));
            return false;
          } 
        }
        // sex
        if (self.detail.sex == null ){
          alert($filter('translate')("SEX.NOT.SET"));
          return false;
        }
        // validate species
        if ((self.detail.species == null || self.detail.species.TaxonID == null) && self.detail.ringInformation != 4){
          alert($filter('translate')("SPECIES.NOT.SET"));
          return false;
        }
        // validate circumstances
        if (self.detail.circumstances == null){
          alert($filter('translate')("CIRCUMSTANCES.NOT.SET"));
          return false;
        }

        // biometrics - validated by form itself (validation inside angular)

        // qualitative fields
        var alula = [self.detail.alula.v1,self.detail.alula.v2,self.detail.alula.v3];
        // is any of the values not null?
        if (alula.indexOf(null) != -1){
          var allNull = true;
          for (i=0;i<alula.length;++i){
            if (alula[i] == null){
              if (!allNull){
                alert($filter('translate')("ALULA.NOT.SET"));
                return false;
              }             
            } else {
              allNull = false;
            }
          }
        }
        // primary moult
        var pm = [self.detail.primaryMoult.v1,self.detail.primaryMoult.v2,
                  self.detail.primaryMoult.v3,self.detail.primaryMoult.v4,
                  self.detail.primaryMoult.v5,self.detail.primaryMoult.v6,
                  self.detail.primaryMoult.v7,self.detail.primaryMoult.v8,
                  self.detail.primaryMoult.v9,self.detail.primaryMoult.v10];
        // is any of the values not null?
        if (pm.indexOf(null) != -1){
          var allNull = true;
          for (i=0;i<pm.length;++i){
            if (pm[i] == null){
              if (!allNull){
                alert($filter('translate')("PRIMARYMOULT.NOT.SET"));
                return false;
              }             
            } else {
              allNull = false;
            }
          }
        }
        // secondary moult
        var pm = [self.detail.secondaryMoult.v1,self.detail.secondaryMoult.v2,
                  self.detail.secondaryMoult.v3,self.detail.secondaryMoult.v4,
                  self.detail.secondaryMoult.v5,self.detail.secondaryMoult.v6];
        // is any of the values not null?
        if (pm.indexOf(null) != -1){
          var allNull = true;
          for (i=0;i<pm.length;++i){
            if (pm[i] == null){
              if (!allNull){
                alert($filter('translate')("SECONDARYMOULT.NOT.SET"));
                return false;
              }             
            } else {
              allNull = false;
            }
          }
        }

        return true;
      }

      this.reset = function(){
        self.date = null;
        self.datePickerOpened = false;
        self.time = null;
        self.note = null;
        self.locality = new Locality();
        self.crdsText = null;
        self.detail = new Observation($rootScope.user.rings.scheme);
        self.detail.ringingScheme = $rootScope.user.rings.scheme;
        self.country = null;
      }

      // save to DB
      this.saveDetail = function(repeat){
        if (self.validate()){
          var dataToSend = self.detail;
          dataToSend['user'] = $rootScope.user;   
          dataToSend['date'] = self.date;
          dataToSend['time'] = self.time;
          dataToSend['lat'] = self.locality.coords.latitude;
          dataToSend['lon'] = self.locality.coords.longitude;
          dataToSend['coobservers'] = self.coobservers;
          dataToSend['owner'] = self.owner;
          dataToSend['sitename'] = self.locality.Name;
          dataToSend['scheme'] = $rootScope.user.rings.scheme;
          if (self.country.Code.indexOf('CZ') == 0){
            dataToSend['KODCOBE'] = self.locality.KODCOBE;
          } else {
            dataToSend['KODCOBE'] = 999999;
          }
          if (self.locality.ID_MunicipalityPart) {
            dataToSend['ID_MunicipalityPart'] = self.locality.ID_MunicipalityPart;
          }
          
          self.send(dataToSend)
            .then(function(result){
              if (!repeat){
                // do not repeat record - redirect to retraps
                if (typeof result.error !== 'undefined'){
                  alert($filter('translate')("SAVE.ERROR"));
                } else {
                  var additionalUrl = "where=idOperation > 3";
                  var rn = self.detail.ringNumber1_retrap.replace(/\s/g,'');
                  additionalUrl += " and ringnumber is '" + rn + "'";
                  /*var fullrn = fullRingNumber(rn);
                  if (fullrn == rn || fullrn === null){
                    additionalUrl += " and ringnumber is '" + rn + "'";
                  } else {
                    additionalUrl += " and (ringnumber is '" + rn + "' or ringNumber is '" + fullrn + "')";
                  } */
                  var params = {"q":additionalUrl};
                  $state.go('app.admin.retraps', params);
                }
              } else {
                // repeat record - keep everything but date
                $location.hash('succesMessage');
                self.showAlert = true;
                self.date = null;
                // reset autocompleter
                //$rootScope.$broadcast('angucomplete-alt:clearInput');
              }
            })
        }
      }

      // send method
      this.send = function(dataToSend){
        var deferred = $q.defer();
        var result = observationService.sendAdminObservation(dataToSend).then(
          function(result) {
            deferred.resolve(result); 
          });
        return deferred.promise;
      }

    }
  }
}])
/*
* directive to display stock
*/
.directive('stock', ['ringsService','$q','$rootScope',function(ringsService,$q,$rootScope){
  return {
    restrict: 'AE',
    templateUrl : 'pages/stock.tpl.html',
    scope : {}, 																						// isolated scope
    controllerAs : 'StockCtrl',
    bindToController: true,
    controller : function (){

    	// variables
    	var self = this;
      //self.rings = [];
    	self.orderMade = false
    	self.doingRingsResolve = false;
      self.updateRingtype = null;

      // load ringtypes
        ringsService.fetchRingTypes(false, $rootScope.user.rings.scheme)
        .then(function(data){
          self.ringtypes = data;
        });

      // load data
      self.loadRings = function(){
        self.doingRingsResolve = true;
        ringsService.fetchRingTypes(false, $rootScope.user.rings.scheme)
        .then(function(data){
          self.ringtypes = data;
          //self.rings = []
          var codes = self.ringtypes.map(function(item,index){return item.Code});
          chain = $q.when();
          codes.forEach(function (el, i) {
            chain = chain.then(self.loadTypeOverview(el));           
          });
          $q.all(chain).then(function(){
            self.doingRingsResolve = false;
          });

        }, function(data){
          alert(data);
       });
      }

    	
    	

    }
  }
}])
/*
* directive to display retraps
*/
.directive('adminRetraps', ['observationService','codebookService','ringsService','$state','myConfig','$rootScope','$uibModal',function(observationService,codebookService,ringsService,$state,myConfig,$rootScope,$uibModal){
  return {
    restrict: 'AE',
    templateUrl : 'pages/admin-retraps.tpl.html',
    scope : {}, 																						// isolated scope
    controllerAs : 'AdminRetrapsCtrl',
    bindToController: true,
    controller : function ($scope){

    	// variables
    	var self = this;
      self.scheme = $rootScope.user.rings.scheme;
    	self.retraps = null;
    	self.numRecords = null;
    	self.retrapItems = null;
    	self.ringItemId = null;
    	self.numRecordsPerPage = 30;
    	self.currentPage = 1;
    	self.formVisible = false;
    	self.showAlert = false;
    	self.loading = false;
      self.doingResolve = false;
    	self.currentItem = {
    		id: null,
    		operation: null,
    		SiteName: null,
    		Latitude: null,
    		Longitude: null,
    		ObsDate: null,
    		status: null,
    		cond: null,
    		circumstances: null,
    		dateAccuracy: null,
    		crdsAccuracy: null,
    		ownerName: null,
    		sex: null,
    		age: null
    	};
    	self.query = {
    		dateFrom: null,
    		dateTo: null,
        dateCreatedFrom: null,
        dateCreatedTo: null,
    		ringingScheme: null,
    		retrapScheme: null,
        ringingSchemeNot: false,
        retrapSchemeNot: false,
    		species: null,
        retrapSpecies: true,
    		ringNumber: null,
        county: null,
        seasonFrom: null,
        seasonTo: null,
        sex: null,
        age: null,
        retrapType: null,
        yearsFrom: null,
        yearsTo: null,
        noringing: 1,
        licenceNumber: null,
        includeRinger: false,
        marktype: null,
        markcolor: null
    	};
      self.order = {
        date: {
          asc: false,
          desc: true
        },
        ringnumber: {
          asc: false,
          desc: false
        },
        species: {
          asc: false,
          desc: false
        },
        sex: {
          asc: false,
          desc: false
        },
        age: {
          asc: false,
          desc: false
        },
        station: {
          asc: false,
          desc: false
        },
        locality: {
          asc: false,
          desc: false
        },
        dateCr: {
          asc: false,
          desc: false
        },
        licenceNumber: {
          asc: false,
          desc: false
        }
      }
    	self.datePicker1Opened = false;
    	self.datePicker2Opened = false;
    	self.retrapLang = 'cz';
      self.retrapType = [
        {"code": 'U',"description": "U - neshválené"}
        ,{"code": 'A',"description": (self.scheme === 'CZP' ? "A - kroužkován v nalezen v ČR" : "A - kroužkován v nalezen v SR")}
        ,{"code": 'Z',"description": (self.scheme === 'CZP' ? "Z - český pták v zahraničí" : "Z - slovenský pták v zahraničí")}
        ,{"code": 'C',"description": (self.scheme === 'CZP' ? "C - cizí pták v ČR" : "C - cizí pták v SR")}
        ,{"code": 'P',"description": "P - v procesu"}
        ,{"code": 'X',"description": "X - ZH nebylo možné ověřit"}];
      // modal window
      self.modalInstance;
      self.additionalUrl = "scheme=" + self.scheme + "&where=idOperation>3";
      self.obceUrl = myConfig[self.scheme].obceUrl;
      self.druhUrl = myConfig[self.scheme].druhUrl;

		  // load codebook
    	codebookService.fetchCodebook()
	      .then(function(data){
	        self.ringingschemes = data.ringingscheme;
          self.age = data.age;
          self.primaryidentificationmethod = data.primaryidentificationmethod;
          self.markcolor = data.markcolor;
	      }, function(data){
	        alert(data);
	      });

      // fetch okresy
      codebookService.fetchOkresy(self.scheme.substring(0,2))
        .then(function(data){
          self.counties = data;          
        }, function(data){
          alert(data);
        });

	     // filter - return true if the species is wader, otherwise return false
	    self.filterEmpty = function() {
	      return function( item ) {
	      	return item.Name.length > 1;
	      };
	    };

	    // created additional url string to be passed to service
			self.constructUrl = function(){
		  	var url = self.additionalUrl;
        var whereRaw = '';
        // add date, if set
		  	if ((self.query.dateFrom != null && self.query.dateFrom != '')
		  		|| (self.query.dateTo != null && self.query.dateTo != '')){
		  		var dateFrom = '1000-01-01';
		  		var dateTo = '9999-12-31';
		  		if (self.query.dateFrom != null && self.query.dateFrom != ''){
		  			var dateFrom = yyyymmdd(self.query.dateFrom);
		  		}
		  		if (self.query.dateTo != null && self.query.dateTo != ''){
		  			var dateTo = yyyymmdd(self.query.dateTo);
		  		}
		  		url += " and date between '"  + dateFrom + "' and '" + dateTo + "'";
		  	}
        // add date created, if set
        if ((self.query.dateCreatedFrom != null && self.query.dateCreatedFrom != '')
          || (self.query.dateCreatedTo != null && self.query.dateCreatedTo != '')){
          var dateCreatedFrom = '1000-01-01';
          var dateCreatedTo = '9999-12-31';
          if (self.query.dateCreatedFrom != null && self.query.dateCreatedFrom != ''){
            var dateCreatedFrom = yyyymmdd(self.query.dateCreatedFrom);
          }
          if (self.query.dateCreatedTo != null && self.query.dateCreatedTo != ''){
            var dateCreatedTo = yyyymmdd(self.query.dateCreatedTo);
          }
          url += " and dateCr between '"  + dateCreatedFrom + "' and '" + dateCreatedTo + "'";
        }
		  	// species
		  	if (self.query.species != null){
		  		// taxonomic tree
          if (self.query.retrapSpecies){
            if (self.query.species.GenusId != 0){
              url += " and taxonid is " + self.query.species.TaxonID;
            } else if (self.query.species.FamilyId != 0){
              url += " and genusid is " + self.query.species.TaxonID;
            } else if (self.query.species.OrderId != 0){
              url += " and familyid is " + self.query.species.TaxonID;
            } else {
              url += " and orderid is " + self.query.species.TaxonID;
            }
          } else {
            if (self.query.species.GenusId != 0){
              url += " and taxonid2 is " + self.query.species.TaxonID;
            } else if (self.query.species.FamilyId != 0){
              url += " and genusid2 is " + self.query.species.TaxonID;
            } else if (self.query.species.OrderId != 0){
              url += " and familyid2 is " + self.query.species.TaxonID;
            } else {
              url += " and orderid2 is " + self.query.species.TaxonID;
            }
          }
		  		
		  	}
        // mark
        if (self.query.marktype != null){
          url += " and markType is '" + self.query.marktype + "'";
        }
        if (self.query.markcolor != null){
          url += " and color is '" + self.query.markcolor + "'";
        }
        
		  	// ringing scheme
		  	if (self.query.ringingScheme != null){
          if (self.query.ringingSchemeNot){
            url += " and (station isnot '" + self.query.ringingScheme + "' or station isnull)";
          } else {
            url += " and station is '" + self.query.ringingScheme + "'";
          }		  		
		  	}
		  	// retrap scheme
		  	if (self.query.retrapScheme != null){
          if (self.query.retrapSchemeNot){
            url += " and (retrapScheme isnot '" + self.query.retrapScheme + "' or retrapScheme isnull)";
          } else {
            url += " and retrapScheme is '" + self.query.retrapScheme + "'";
          }		  		
		  	}
        // county
        if (self.query.county != null){
          url += " and county is '" + self.query.county + "'";
        }
        // age
        if (self.query.age != null){
          url += " and age is '" + self.query.age + "'";
        }
        // sex
        if (self.query.sex != null){
          url += " and sex is '" + self.query.sex + "'";
        }
		  	// retrap type
		  	if (self.query.retrapType != null){
          if (self.scheme==='CZP') {
            url += " and retrapType is '" + self.query.retrapType + "'";
          } else {
            url += " and retrapTypeSKB is '" + self.query.retrapType + "'";
          }
		  	}
		  	// ringnumber
		  	if (self.query.ringNumber){
          var rn = self.query.ringNumber.replace(/\s/g,'');
          url += " and ringnumber is '" + rn + "'";
          /*var fullrn = fullRingNumber(rn);
          if (fullrn == rn || fullrn === null){
            url += " and ringnumber is '" + rn + "'";
          } else {
            url += " and (ringnumber is '" + rn + "' or ringNumber is '" + fullrn + "')";
          }  */        
		  	}
		  	// municipality
		  	if (self.query.municipality != null){
		  		url += " and municipalityId is " + self.query.municipality;
		  	}
		  	// projects
        if(self.query.ces){
          url += " and ces is 1";
        }
        if(self.query.ras){
          url += " and ras is 1";
        }
		  	// licence number
		  	if (self.query.licenceNumber != null && self.query.licenceNumber != ''){
          if ( self.query.includeRinger ) {
            url += " and (licenceNumber is '" + self.query.licenceNumber + "' or licenceNumberRinger is '" + self.query.licenceNumber + "')";
          } else {
            url += " and licenceNumber is '"  + self.query.licenceNumber + "'";
          }		  		
		  	}
		  	// owner
		  	if (self.query.owner != null && self.query.owner != ''){
		  		url += " and ownerName like '%"  + self.query.owner + "%'";
		  	}
        // missing ringing data
        if (self.query.noringing > 1){
          url += " and ringingMissing is "  + (self.query.noringing == 2 ? 1 : 0);
        }
        // season
        /*if (self.query.seasonFrom != null && self.query.seasonTo != null){
          var regexPattern = /^([0-9]{1,2})\.([0-9]{1,2})?$/i;
          var matchFrom = regexPattern.exec(self.query.seasonFrom);
          var mFrom = matchFrom[2];
          var dFrom = matchFrom[1];
          var matchTo = regexPattern.exec(self.query.seasonTo);
          var mTo = matchTo[2];
          var dTo = matchTo[1];
          var strFrom = ("0" + mFrom).slice (-2) + '' + ("0" + dFrom).slice (-2);
          var strTo = ("0" + mTo).slice (-2) + '' + ("0" + dTo).slice (-2);
          if (strFrom > strTo){
            whereRaw += "AND DATE_FORMAT(date, '%m%d') > " + strFrom + " OR DATE_FORMAT(date, '%m%d') < " + strTo + ' ';
          } else {
            whereRaw += "AND DATE_FORMAT(date, '%m%d') BETWEEN " + strFrom + " AND " + strTo + ' ';
          }
        }*/
        if (self.query.yearsFrom != null && self.query.yearsTo != null){
          whereRaw += "AND YEAR(date) BETWEEN " + self.query.yearsFrom + " AND " +  self.query.yearsTo;
        }
        // add raw where
        if (whereRaw.length > 0){
          url += "&whereRaw=" + encodeURI(whereRaw);
        }
        // add order only of not already present
        if (url.indexOf('&order') === -1){
          url += self.constructOrder();
        }
		  	return encodeURI(url);
		  }

      if (typeof $state.params.q !== 'undefined' && $state.params.q !== null && $state.params.q !== ''){
        self.additionalUrl = "scheme=" + $rootScope.user.rings.scheme + '&' +  $state.params.q;
        self.doingResolve = true;
        observationService.fetchRetraps(1,self.numRecordsPerPage,self.additionalUrl)
          .then(function(data){
            if (data.items.length == 0){
              self.showAlert = true;
            }
            // reset additional url
            self.additionalUrl = "scheme="+ $rootScope.user.rings.scheme + '&where=idOperation > 3';

            self.retraps = data.items;
            self.numRecords = data.rowCount;
            self.doingResolve = false;
          }, function(data){
            alert("Při načítání dat došlo k chybě");
            self.doingResolve = false;
        });
      }

	    /*set class based on combination where bird was ringed and retrapped*/
	    self.rowClass = function(record){
        let val = self.scheme === 'CZP' ? record.retrapType : record.retrapTypeSKB;
	    	switch(val){
          case 'U': // not approved
            return 'danger';
	    		case 'A': // czech bird in CZ
	    			return 'success';
	    		case 'C': // foreign bird in CZ
	    			return 'warning';
	    		case 'Z': // czech bird in other country
	    			return 'info';
	    		default:
	    			return null;
	    	}
      }

      // adds order to url
      self.constructOrder = function(){
        var url = "&order=";
        if (self.order.date.asc){
          return url +='date asc';
        } else if (self.order.date.desc){
          return url +='date desc';
        } else if (self.order.ringnumber.asc){
          return url +='ringnumber asc';
        } else if (self.order.ringnumber.desc){
          return url +='ringnumber desc';
        } else if (self.order.species.asc){
          return url +='species asc';
        } else if (self.order.species.desc){
          return url +='species desc';
        } else if (self.order.sex.asc){
          return url +='sex asc';
        } else if (self.order.sex.desc){
          return url +='sex desc';
        } else if (self.order.age.asc){
          return url +='ageid asc';
        } else if (self.order.age.desc){
          return url +='ageid desc';
        } else if (self.order.station.asc){
          return url +='station asc';
        } else if (self.order.station.desc){
          return url +='station desc';
        } else if (self.order.locality.asc){
          return url +='locality asc';
        } else if (self.order.locality.desc){
          return url +='locality desc';
        } else if (self.order.dateCr.asc){
          return url +='dateCr asc';
        } else if (self.order.dateCr.desc){
          return url +='dateCr desc';
        } else if (self.order.licenceNumber.asc){
          return url+='licenceNumber asc'
        } else if (self.order.licenceNumber.desc){
          return url+='licenceNumber desc'
        }
        return "";
      }
      // resets order of columns
      self.resetOrder = function(){
        self.order = {
          date: {
            asc: false,
            desc: false
          },
          ringnumber: {
            asc: false,
            desc: false
          },
          species: {
            asc: false,
            desc: false
          },
          sex: {
            asc: false,
            desc: false
          },
          age: {
            asc: false,
            desc: false
          },
          station: {
            asc: false,
            desc: false
          },
          locality: {
            asc: false,
            desc: false
          },
          dateCr: {
            asc: false,
            desc: false
          },
          licenceNumber: {
            asc: false,
            desc: false
          }
        }
      }

      self.changeOrder = function(type){
        var asc = self.order[type].asc;
        self.resetOrder();
        if (asc){
          self.order[type].desc = true;
        } else {
          self.order[type].asc = true;
        }
        self.getRetraps();
      }

      // retrap - ringing records
      self.getRetraps = function(){
        self.doingResolve = true;
        observationService.fetchRetraps(1,self.numRecordsPerPage,self.constructUrl())
          .then(function(data){
            if (data.items.length == 0){
              self.showAlert = true;
            }
            self.retraps = data.items;
            self.numRecords = data.rowCount;
            self.doingResolve = false;
          }, function(data){
            alert("Při načítání dat došlo k chybě");
            self.doingResolve = false;
        });
      }

		  self.pageChanged = function(newPageNumber){
        self.doingResolve = true;
		  	observationService.fetchRetraps(newPageNumber,self.numRecordsPerPage,self.constructUrl())
		    .then(function(data){
		    	//self.currentPage = newPageNumber;
		      self.retraps = data.items;
		      self.numRecords = data.rowCount;
          self.doingResolve = false;
		    }, function(data){
		      alert("Při načítání dat došlo k chybě");
          self.doingResolve = false;
		  	});
		  }

      // open modal window with user detail
      this.approveRetrap = function(record){
        self.doingResolve = true;
        self.currentItem.id = record.ID;

        self.currentRecord = record;

        var modalScope = $scope.$new();
        
        self.modalInstance = $uibModal.open({
          template: '<admin-retrap-modal-window record="AdminRetrapsCtrl.currentRecord" instance="AdminRetrapsCtrl.modalInstance"></admin-retrap-modal-window>',
          size: 'lg',
          scope: modalScope
        });
        self.doingResolve = false;
      }

      // delete ring item
      self.deleteRetrap = function(record){
        var ringnumber = record.ringnumber
        //if (self)
        if(confirm('Opravdu chcete smazat záznam kroužku '+ringnumber+'?')){
          var id = record.ringItemId;
          var newringing = false;
          var station = record.retrapScheme;
          var additionalUrl = '?id='+id+"&ringnumber="+ringnumber+"&ringing="+newringing+"&station="+station;
          observationService.deleteRingItem(additionalUrl).then(
            function(result) {
              if (typeof result.ok === 'undefined' || !result.ok){
                alert("Chyba, nepodařilo se smazat záznam");
              } else {
                alert('Záznam byl úspěšně smazán');
              }
            }
          );
        }
      }

		  self.showForm = function(){
		  	self.formVisible = true;
		  }

		  self.openDatePicker = function(val){
        let param = 'datePicker' + val + 'Opened';
        self[param] = true;
		  }

		  self.pdfUrl = function(path){
		  	//var url = myConfig.apiUrl.replace('v1/','userdata/rings/reports/'+path);
        var url = 'https://rings.birds.cz/userdata/rings/reports/' + path;
		  	return url;
		  }

		  // reset all form options
			self.resetForm = function(){
			  self.query = {
	    		dateFrom: null,
	    		dateTo: null,
	    		ringingScheme: null,
	    		retrapScheme: null,
          ringingSchemeNot: false,
          retrapSchemeNot: false,
	    		species: null,
          retrapSpecies: true,
	    		ringNumber: null,
	        seasonFrom: null,
	        seasonTo: null,
	        sex: null,
	        age: null,
	        retrapType: null,
	        yearsFrom: null,
	        yearsTo: null,
          noringing: 1,
          licenceNumber: null,
          includeRinger: false,
          marktype: null,
          color: null
	    	};
        self.resetOrder();
		    // reset autocompleter
		    $rootScope.$broadcast('angucomplete-alt:clearInput');
			}

			 // when autocompleter option for municipality is selected, update model
    	this.updateMunicipality = function (selectedValue) {
    		if (!selectedValue) {
          self.query.municipality = null;
          return;
        }
        if (selectedValue) {
          self.query.municipality = selectedValue.originalObject.ID;
        }
    	};

    	// when autocompleter option for species is selected, update model
    	this.updateSpecies = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
          self.query.species = null;
          return;
        }
        self.query.species = selectedValue.originalObject; 
    	};

      // when autocompleter option for municipality is selected, update model
      this.updateRinger = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
          self.query.licenceNumber = null;
          return;
        }
        self.query.licenceNumber = selectedValue.originalObject.LicenceNumber;
      };
    }
  }
}])
/*user detail modal window*/
.directive('adminRetrapModalWindow',['$rootScope','$filter','observationService','usersService','codebookService','mailService','ringsService','amMoment','myConfig'
  ,function($rootScope,$filter,observationService,usersService,codebookService,mailService,ringsService,amMoment,myConfig){
  return {
    restrict : 'E',
    templateUrl : 'templates/retrap-modal.tpl.html',
    scope : { 
      record : '=',
      instance: "="
    },
    controllerAs : 'ModalRetrapCtrl',
    bindToController: true,
    controller : function ($scope){

      var self = this;
      self.showAlert = false;
      self.loading = false;
      self.retrapLang = ($rootScope.user.rings.scheme === 'CZP' ? "cz" : "sk");
      self.ownerScheme = $rootScope.user.rings.scheme;
      self.scheme = $rootScope.user.rings.scheme;
      self.druhUrl = myConfig[self.ownerScheme].druhUrl;
      self.ageCodebook = [];
      self.sexCodebook = [];
      //self.schemesCodebook = [];
      self.originalRetrapId = self.record.retrapId;
      self.originalRetrapType = (self.ownerScheme === 'CZP') ? self.record.retrapType : self.record.retrapTypeSKB;
      self.originalVerified = self.record.retrapApproved;
      self.retrapType = [
        {"code": 'U',"description": "U - neshválené"}
        ,{"code": 'A',"description": ($rootScope.user.rings.scheme === 'CZP' ? "A - kroužkován v nalezen v ČR" : "A - kroužkován v nalezen v SR")}
        ,{"code": 'Z',"description": ($rootScope.user.rings.scheme === 'CZP' ? "Z - český pták v zahraničí" : "Z - slovenský pták v zahraničí")}
        ,{"code": 'C',"description": ($rootScope.user.rings.scheme === 'CZP' ? "C - cizí pták v ČR" : "C - cizí pták v SR")}
        ,{"code": 'P',"description": "P - v procesu"}
        ,{"code": 'X',"description": "X - ZH nebylo možné ověřit"}];

       self.languages = [{"code": "cz","description": "Česky"},{"code": "en","description": "Anglicky"}];
       if ($rootScope.user.rings.scheme === 'SKB') {
         self.languages = [{"code": "sk","description": "Slovensky"},{"code": "en","description": "Anglicky"}];
       }


      codebookService.fetchCodebook()
        .then(function(data){
          self.ageCodebook = data.age;
          //self.schemesCodebook = data.ringingscheme;
        }, function(data){
          alert(data);
        });

        var rn = self.record.ringnumber;
        if (rn.length == 10){
          var rnparts = dissectRingNumber(rn);
          if (rnparts && rnparts.length == 2){
            rn = rnparts[0] + rnparts[1];
          }
        }

        self.removeItem = function(id){
          var itemsFiltered = self.retrapItems.filter(function(el) {
              return el.ID !== id;
          });
          self.retrapItems = itemsFiltered;
          if (self.ringingData.ID == id){
            self.ringingData = null;
            self.metalring = self.retrapData.ringnumber;
            self.metalscheme = null;
            // mail ringer
            self.mailRinger = '';
          }
        }

        self.setAsRinging = function(item){
          self.ringingData = item;
          self.metalring = item.ringnumber;
          self.metalscheme = item.retrapScheme;
          // mail ringer
          self.mailRinger = item.ownerMail;         
        }
        
        self.load = function(reringing){
          self.loading = true;
          observationService.fetchRetrapHistory(rn,self.record.station,self.record.markType,self.record.color,self.record.ringItemId,reringing,self.record.taxonid)
            .then(function(data){
              for (var i = 0; i<data.length; i++) {
                if (data[i].coobservers) {
                  var match = data[i].coobservers.match(/([\w-\.]+)@((?:[\w]+\.)+)([a-zA-Z]{2,4})/g);
                  if (match){
                    if (!self.mailRinger) {
                      self.mailRinger = match[0];
                    }
                    if (!self.mailRinger.includes(match[0])) {
                      self.mailRinger += ', ' + match[0];
                    }                      
                  }
                }
                if (data[i].ownerMail === 'krouzkovaci.stanice@nm.cz') {
                  continue;
                }
                /*if (!self.mailRinger) {
                  self.mailRinger = data[i].ownerMail;
                } else if (!self.mailRinger.includes(data[i].ownerMail)) {
                  self.mailRinger += ', ' + data[i].ownerMail;
                } */
              }
              self.retrapItems = data;
              self.ringingData = null;
              self.retrapData = null;
              self.color = self.record.colorNameEng;
              self.ringItemId = self.record.ringItemId;
              self.scheme = self.record.station;
              self.code = self.record.ringnumber;
              self.metalring = self.record.ringnumber;
              self.metalscheme = self.record.station;
              self.method = self.record.markType;
              self.ringerName = null;
              self.species = null;
              self.age = null;
              self.sex = null;
              self.distance = null;
              self.direction = null;
              self.elapsed = null;
              // text
              self.mailText2 = "Žádost o zadání kroužkovacích dat\n\n"
              +"Vážená kolegyně, vážený kolego,\n\n"
              +"obdrželi jsme záznam o nálezu ptáka s kroužkem "+$filter('ringnumber')(self.code)
              +", u kterého zatím chybí data kroužkování. Vzhledem k tomu, že tento kroužek je registrován na Vaše jméno,"
              +" prosíme o zadání kroužkovacích dat do aplikace Rings (rings.birds.cz). "
              +"Pokud se jedná o chybný odečet kroužku a kroužek máte nepoužitý, dejte nám prosím vědět na adresu"
              +" lucie.fuchsova@nm.cz.\n\n"
              +"Na tento mail neodpovídejte. \n\n"
              +"Děkujeme Vám za spolupráci.\n\n"
              +"Kroužkovací stanice\n"
              +"Národní muzeum\n"
              +"Hornoměcholupská 34\n"
              +"102 00 Praha 10-Hostivař"
              if ($rootScope.user.rings.scheme === 'SKB') {
                self.mailText2 = "Žiadosť o zadanie krúžkovacích údajov\n\n"
              +"Vážená kolegyňa, vážený kolega,\n\n"
              +"obdržali sme záznam o náleze vtáka s krúžkom "+$filter('ringnumber')(self.code)
              +",  ktorého zatiaľ chýbajú krúžkovacie údaje. Vzhľadom k tomu, že tento krúžok je registrovaný na Vaše meno, prosíme o zadanie krúžkovacích údajov do aplikácie Rings (rings.birds.cz). Pokiaľ sa jedná o chybné odčítanie krúžku a krúžok máte nepoužitý, dajte nám to prosím vedieť na adresu kruzkysk@gmail.com.\n\n"
              +"Na tento mail neodpovedajte. \n\n"
              +"Ďakujeme Vám za spoluprácu.\n\n"
              +"Krúžkovacia stanica\n"
              +"SOS BirdLife Slovensko\n"
              +"Námestie osloboditeľov 1\n"
              +"07101 Michalovce\n"
              };
              // mails
              self.mailRinger = self.record.ownerMail;
              // construct mail body
              self.getMailBody();
              
              // update ringitem - original ringing id
              var firstDate=new Date(9999,12,31);
              //var finderMails = self.record.ownerMail ? [self.record.ownerMail] : [];
              //self.mailFinder = self.record.ownerMail ? self.record.ownerMail : null;
              //var firstId = null;
              for (var i = 0; i < self.retrapItems.length; i++){
                // set mail of finders - if ringer
                /*if (self.retrapItems[i].ownerMail) {
                  if (finderMails.indexOf(self.retrapItems[i].ownerMail) < 0 && self.retrapItems[i].ownerMail) {
                    finderMails.push(self.retrapItems[i].ownerMail);
                  }
                }
                // set mail of finders - if coobserver
                if (self.retrapItems[i].coobservers) {
                  var match =self.retrapItems[i].coobservers.match(/([\w-\.]+)@((?:[\w]+\.)+)([a-zA-Z]{2,4})/g);
                  if (match){
                    if (finderMails.indexOf(match[0]) < 0 && match[0]) {
                      finderMails.push(match[0]);
                    }
                  }
                }*/
                // set retrap data
                if (self.retrapItems[i].ID == self.record.ringItemId){
                  self.retrapData = self.retrapItems[i];
                  self.retrapData.retrapType = self.originalRetrapType;
                  self.retrapData.retrapApproved = self.originalVerified;
                  // set finder
                  if (self.retrapItems[i].coobservers) {
                    var match =self.retrapItems[i].coobservers.match(/([\w-\.]+)@((?:[\w]+\.)+)([a-zA-Z]{2,4})/g);
                    if (match){
                      if (!self.mailRinger) {
                        self.mailRinger = match[0];
                      }
                      if (!self.mailRinger.includes(match[0])) {
                        self.mailRinger += ', ' + match[0];
                      }                      
                    }
                  }
                }
                // set ringing data
                if (new Date(self.retrapItems[i].date) < firstDate && self.retrapItems[i].markType == 'A0'
                  && self.retrapItems[i].idOperation < 4){
                  //firstId = self.retrapItems[i].ID;
                  self.ringingData = self.retrapItems[i];
                  self.metalring = self.retrapItems[i].ringnumber;
                  self.metalscheme = self.retrapItems[i].station;
                  // mail ringer
                  if (!self.mailRinger) {
                    self.mailRinger = self.ringingData.ownerMail;
                  } else if (self.ringingData.ownerMail && !self.mailRinger.includes(self.ringingData.ownerMail)) {
                    if (self.ringingData.ownerMail !== 'krouzkovaci.stanice@nm.cz') {
                      self.mailRinger += ', ' + self.ringingData.ownerMail;
                    }
                  }
                  //self.mailRinger = self.ringingData.ownerMail;                 
                }
                if (self.retrapItems[i].mrkIdOperation && self.retrapItems[i].mrkIdOperation < 4) {
                  if (!self.mailRinger) {
                    self.mailRinger = self.retrapItems[i].ownerMail;
                  } else if (!self.mailRinger.includes(self.retrapItems[i].ownerMail)) {
                    if (self.retrapItems[i].ownerMail !== 'krouzkovaci.stanice@nm.cz') {
                      self.mailRinger += ', ' + self.retrapItems[i].ownerMail;
                    }                    
                  }
                }
                // set station if other than owners
                if (self.metalscheme && self.metalscheme !== self.ownerScheme) {
                  usersService.fetchUsersRaw('?where=ID_RingingScheme is \'' + self.metalscheme + '\' and bitMask>=4')
                    .then(function(response) {
                      if (response.length) {
                        self.mailStation = response[0].Email;
                      }
                    })
                }             
              }
              /*if (finderMails.indexOf('krouzkovaci.stanice@nm.cz') >=0) {
                finderMails.splice(finderMails.indexOf('krouzkovaci.stanice@nm.cz'),1);
              }*/
              //self.mailFinder = finderMails.join(',');
              // set retrap type
              self.setRetrapType();
              self.loading = false;

              // get species, age, sex by scheme
              var additionalUrl = "?where=ID is "+self.record.ringItemId;
              observationService.fetchRingItem(additionalUrl)
                .then(function(data){
                  if (data.length > 0){
                    if (data[0]['ID_SexByScheme'] != null){
                      self.sex = data[0]['ID_SexByScheme'].toString();
                    }              
                    self.age = data[0]['ID_AgeByScheme'];
                    self.verifiedByScheme = data[0]['VerifiedByScheme'] == 1;
                    self.species = {
                      Name: data[0]['NameCZ'],
                      TaxondID: data[0]['ID_SpeciesByScheme']
                    }
                  }              
              });
                // get ringer mail, if ringing is missing
                if (!self.retrapData.ringingId && (self.retrapData.station === $rootScope.user.rings.scheme)){
                  var rn = dissectRingNumber(self.code);
                  if (rn !== null){
                    var additionalUrl = "?serie="+rn[0]+"&number="+rn[1]+"&scheme="+self.retrapData.station;
                    ringsService.fetchRingerInfo(additionalUrl)
                      .then(function(data){
                        if (data.length > 0){
                          self.mailUrge = data[0].Email;
                          self.ringerName = data[0].Name + ' ' + data[0].Surname;
                        }
                        self.setRetrapType();
                      });
                  }
                  
                }

          }, function(data){
            self.currentItem.id = null;
            alert("Při načítání dat došlo k chybě");
        });
        }

      self.load(false);

      self.setRetrapType = function() {
        // set retrap type, if U
        var colname = $rootScope.user.rings.scheme === 'CZP' ? 'retrapType' : 'retrapTypeSKB';
        if (self.retrapData.retrapType === 'U' || self.retrapData.retrapType === 'P') {
          // ringing data present
          if (self.retrapData.ringingId) {
            if (self.retrapData.station && 
              (self.retrapData.station !== $rootScope.user.rings.scheme)) {
              self.record[colname] = 'C';
            } else if (self.retrapData.station && 
              (self.retrapData.station === $rootScope.user.rings.scheme) 
              && self.inMyCountry(self.retrapData.placeCode)) {
              self.record[colname] = 'A';
            } else if (self.retrapData.station && 
              (self.record.station === $rootScope.user.rings.scheme) 
              && !self.inMyCountry(self.retrapData.placeCode)) {
              self.record[colname] = 'Z';
            }
            self.retrapTypeChanged();
          } else {
            // ringer not
            if (!self.mailUrge) {
              self.record[colname] = 'U';
            } else {
              self.record[colname] = 'P';
            }        
          }          
        }
      }

      self.inMyCountry = function(placecode) {
        if (!placecode) return false;
        var myCountry = $rootScope.user.rings.scheme.substring(0,2);
        var recordCountry = placecode.substring(0,2);
        return myCountry === recordCountry;
      }        

      self.getMailBody = function(){
        switch(self.retrapLang){
          case 'cz':
            self.mailText = "Informace o nálezu okroužkovaného ptáka\n\n"
            +"Vážená paní, vážený pane,\n\n"
            +"v příloze naleznete informaci o nálezu ptáka s kroužkem "+(self.record.station ? (self.record.station+' ') : '')  + self.record.ringnumber
            +". V případě zjištění nesrovnalostí/nepřesností nás, prosím, kontaktujte na adrese"
            +" lucie.fuchsova@nm.cz.\n\n"
            +"Na tento mail neodpovídejte. \n\n"
            +"Děkujeme Vám za spolupráci.\n\n"
            +"Kroužkovací stanice\n"
            +"Národní muzeum\n"
            +"Hornoměcholupská 34\n"
            +"102 00 Praha 10-Hostivař"
            break;    
          case 'en':
            var mail = "krouzkovaci_stanice@nm.cz";
            var address = "Bird Ringing Centre\n"
                        +"National Museum\n"
                        +"Hornoměcholupská 34\n"
                        +"102 00 Praha 10-Hostivař\n"
                        +"Czechia";
            if ($rootScope.user.rings.scheme === 'SKB') {
              mail = "kruzkysk@gmail.com";
              var address = "Bird Ringing Centre\n"
                        +"SOS BirdLife Slovensko\n"
                        +"Námestie osloboditeľov 1\n"
                        +"07101 Michalovce\n"
                        +"SLOVAKIA";
            }
            self.mailText = "Report on a ringed bird\n\n"
            +"Dear all,\n\n"
            +"as attached below there is a recovery report on the ring "+(self.record.station ? self.record.station : '') + ' ' + self.record.ringnumber
            +". Please send us a short note if you find any errors in the report.\n\n"
            +"Do not reply to this message. Use e-mail "+mail+" for further communication.\n\n"
            +"Thank you very much for your cooperation!\n\n"
            +address
            break;
          case 'sk':
            self.mailText = "Informácia o náleze krúžkovaného vtáka\n\n"
            +"Vážená pani, vážený pán,\n\n"
            +"V prílohe nájdete informáciu o náleze vtáka s krúžkom "+(self.record.station ? (self.record.station+' ') : '')  + self.record.ringnumber
            +". V prípade zistenia nezrovnalostí/nepresností nás, prosím, kontaktujte na adrese kruzkysk@gmail.com\n\n"
            +"Na tento mail neodpovedajte. \n\n"
            +"Ďakujeme Vám za spoluprácu.\n\n"
            +"Krúžkovacia stanica\n"
            +"SOS BirdLife Slovensko\n"
            +"Námestie osloboditeľov 1\n"
            +"07101 Michalovce\n"
            +"SLOVAKIA"
            break;   
        }
      }

      // retrap type changed
      self.retrapTypeChanged = function(){
        if (self.record.retrapType != 'U'){
          self.record.retrapApproved = true;
        }
      }

      // get url of pdf
      self.pdfUrl = function(path){
        var url = myConfig.apiUrl.replace('v1/','userdata/rings/reports/'+path);
        // TODO - replace
        //url = url.replace('8080','8889');
        // END TODO
        return url;
      }

      // when autocompleter option for species is selected, update model
      this.updateSpecies = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
          self.species = null;
          return;
        }
        self.species = selectedValue.originalObject; 
      };

      // when autocompleter option for ringer is selected, update model
      this.updateRinger = function(selectedValue){
        if (selectedValue){
          self.mailUrge = selectedValue.originalObject.Email;
        }
      }

      self.updateRingItem = function(){
        var dataToSend = {
          ID: self.originalRetrapId,
          RetrapApproved: self.record.retrapApproved ? 1 : 0,
          ID_RetrapType: self.record.retrapType,
          ID_RetrapTypeSKB: self.record.retrapTypeSKB
        }
        // retrapScheme - based on user scheme and ring scheme
        var colname = $rootScope.user.rings.scheme === 'CZP' ? 'retrapType' : 'retrapTypeSKB';
        if (self.ownerScheme === 'CZP') {
          if (self.record.retrapScheme === 'SKB' && dataToSend.ID_RetrapType === 'Z') {
            dataToSend.ID_RetrapTypeSKB = 'C';
          } else if (self.record.ringingStation === 'SKB' && dataToSend.ID_RetrapType === 'C') {
            dataToSend.ID_RetrapTypeSKB = 'Z';
          }
        } else if (self.ownerScheme === 'SKB') {
          if (self.record.retrapScheme === 'CZP' && dataToSend.ID_RetrapTypeSKB === 'Z') {
            dataToSend.ID_RetrapType = 'C';
          } else if (self.record.ringingStation === 'SKB' && dataToSend.ID_RetrapTypeSKB === 'C') {
            dataToSend.ID_RetrapType = 'Z';
          }
        }
        if (self.species !== null){
          dataToSend['ID_SpeciesByScheme'] = self.species.TaxonID;
        }
        if (self.age !== null){
          dataToSend['ID_AgeByScheme'] = self.age;
        }
        if (self.sex !== null){
          dataToSend['ID_SexByScheme'] = self.sex;
        }
        if (self.ringingData){
          dataToSend['ID_Ringing'] = self.ringingData.ID;
        }
        if (self.ringingData){
          dataToSend['RingItemId'] = self.ringingData.ID;
        }
        dataToSend['Note'] = self.record.retrapNote;
        // scheme
        let schemes = self.record.schemes;
        if (self.retrapData.country === 'Slovakia' && !schemes.includes('SKB')) {
          schemes += ',SKB'
        }
        if (self.retrapData.country === 'Czechia' && !schemes.includes('CZP')) {
          schemes += ',CZP'
        }
        if (self.retrapData.retrapScheme && !schemes.includes(self.retrapData.retrapScheme)) {
          schemes += ',' + self.retrapData.retrapScheme;
        }
        if (self.ringingData && self.ringingData.station && !schemes.includes(self.ringingData.station)) {
          schemes += ',' + self.ringingData.station;
        }
        dataToSend['Schemes'] = schemes;
        //console.log(dataToSend);
        // update ID_OriginalRinging
        observationService.updateRetrapItem(dataToSend,true)
          .then(function(data){
            self.showAlert = true;
          });
      }

      /*
      generate pdf from all records
      */
      self.generatePdf = function(){
        var dataToSend = {
          ID: self.originalRetrapId,
          RetrapApproved: self.record.retrapApproved ? 1 : 0,
          ID_RetrapType: self.record.retrapType
        }
        if (self.species !== null){
          dataToSend['ID_SpeciesByScheme'] = self.species.TaxonID;
        }
        if (self.age !== null){
          dataToSend['ID_AgeByScheme'] = self.age;
        }
        if (self.sex !== null){
          dataToSend['ID_SexByScheme'] = self.sex;
        }
        if (self.ringingData){
          dataToSend['ID_Ringing'] = self.ringingData.ID;
        }
        if (self.ringingData){
          dataToSend['RingItemId'] = self.ringingData.ID;
        }
        self.loading = true;

        // update ID_OriginalRinging
        observationService.updateRetrapItem(dataToSend,true)
          .then(function(data){
            var body = {
              id: self.ringItemId,
              scheme: self.scheme,
              ringingscheme: self.metalscheme,
              code: self.code,
              metalring: self.metalring,
              method: self.method,
              lang: self.retrapLang,
              type: self.record.retrapType,
              items: self.retrapItems,
              ownerScheme: self.ownerScheme
            };
            observationService.generateRetrapPdf(body) 
              .then(function(data){
                self.record.pathToFile = data.reportName;
                self.getMailBody();
                self.loading = false; 
                self.showAlert  = true;
              }, function(data){
                self.loading = false;
                alert("Při načítání dat došlo k chybě");
            });
          });
        }

      // send email to user
      self.sendEmail = function(){
        var regex = /^([1-9]{0,1}[a-zA-Z]+)0*([1-9][0-9]*)$/i;     // validates ring number
        var match = regex.exec(self.code);

        var type = null;
        var number = null;
        if (match != null){ // should never be null
          var type = match[1];
          var number = match[2];
        }

        var body = {
          subject: "Žádost o zadání kroužkování",
          to: self.mailUrge,
          text: self.mailText2,
          html: self.mailTextHtml2,
          id: self.record.retrapId,
          type: type,
          schema: self.metalscheme,
          number: number,
          scheme: self.ownerScheme,
        }
        observationService.sendEmail(body)
          .then(function(data){
            if (data.error){
              switch(data.error){
                case 'ring_not_found':
                  alert('Nepodařilo se najít majitele kroužku, zkontrolujte, zda je kroužek z ČR');
                  break;
                case 'incorrect ringnumber':
                  alert('Číslo kroužku je v neznámém formátu');
                  break;
                case 'ringnumber missing':
                  alert('Neznámé číslo kroužku');
                  break;
                default:
                  alert('Při odesílání mailu došlo k chybě, kontaktujte programátora');
                  break;
              }
            } else {
              self.showAlert = true;
            }
          });
      }

      // send mail with pdf
      self.sendMails = function(){
        var to = [];
        if (self.mailRinger){
          to.push(self.mailRinger);
        }
        if (self.mailFinder){
          to.push(self.mailFinder);
        }
        if (self.mailStation){
          to.push(self.mailStation);
        }
        if (to.length > 0){
          var opt = {
            scheme: self.ownerScheme,
            to: to,
            subject: 'Retrap ' + self.retrapData.station + ' ' + self.retrapData.ringnumber,
            text: self.mailText,
            filePath: self.record.pathToFile,
            fileType: 'application/pdf',
            fileName: (self.retrapData.station + '_' + self.retrapData.ringnumber.replace(' ','') + '.pdf') //'retrapReport.pdf'
          }

          mailService.sendEmail(opt)
            .then(function(data){
              if (data.error){
                alert('Nepodařilo se odeslat mail');
              } else {
                self.showAlert = true;
              }
            });

        } else {
          alert('Nejsou zadány mailové adresy příjemců!');
        }
        
      }

      self.cancel = function(){
        self.instance.close();
      }

    }  

  }
}])
/*
* displays table with the records of certain user
*/
.directive('adminOrders', ['ringsService','$state','$rootScope',function(ringsService,$state,$rootScope){
  return {
    restrict: 'AE',
    templateUrl : 'pages/admin-orders.tpl.html',
    scope : {}, 																						// isolated scope
    controllerAs : 'AdminOrdersCtrl',
    bindToController: true,
    controller : function (){

    	// variables
    	var self = this;
    	self.orders = null;
    	self.ringOrderStatus = null;
    	self.search = null;
      self.searchSummary = {
        from: null,
        to: null
      }
    	self.searchType = null;

    	// load ring orders overview
    	ringsService.fetchRingOrdersOverview('order=DateCreated desc&where=ID_RingingScheme is \'' + $rootScope.user.rings.scheme + '\'')
		    .then(function(data){
		      self.orders = data;
		    }, function(data){
		      alert("Při načítání dat došlo k chybě");
		  });

      
		  // load ring order status
    	ringsService.fetchRingOrdersStatus()
		    .then(function(data){
		      self.ringOrderStatus = data;
		    }, function(data){
		      alert("Při načítání dat došlo k chybě");
		  });

		  // update search status
		  self.updateSearch = function(){
		   	if(this.search.Status == null){
		   		this.search.Status = '';
		   	}
		  }

      self.openDatePicker = function(val){
        let param = 'datePicker' + val + 'Opened';
        self[param] = true;
      }

      self.getSummary = function() {
        // load ring orders summary
        var additionalUrl = 'scheme=' + $rootScope.user.rings.scheme;
        additionalUrl += '&from=' + yyyymmdd(self.searchSummary.from);
        additionalUrl += '&to=' + yyyymmdd(self.searchSummary.to);
        ringsService.fetchRingOrdersSummary(additionalUrl)
          .then(function(data){
            self.summary = data;
          }, function(data){
            alert("Při načítání dat došlo k chybě");
        });

      }

		  // filter - return true if user fits the pattern
	    self.filterOrders = function() {
	      return function( order ) {
	      	// if searchType is null or epmty, return all
	      	if (self.searchType == null
	      		|| self.searchType == ''){
	      		return true;
	      	}
	      	// if ID_RingTypeOrdered is not set, return false
	      	if (order.ID_RingTypeOrdered == null || order.ID_RingTypeOrdered == ''){
	      		return false;
	      	}
	      	// if ID_RingTypeOrdered passes the condition, return true 
	      	if (order.ID_RingTypeOrdered.indexOf(self.searchType) != -1){
	      		return true;
	      	} else {
	      		// if ID_RingTypeAssigned is not null or empty, check it
	      		if (order.ID_RingTypeAssigned == null || order.ID_RingTypeAssigned == ''){
	      			return false;
	      		} else {
							if (order.ID_RingTypeAssigned.indexOf(self.searchType) != -1){
			      		return true;
			      	} else {
			      		return false;
			      	}
	      		}	      		
	      	}
	      };
	    };

		}
  }
}])
/*
* directive to display RAS records and export them to csv
*/
.directive('adminRas',['rasService','$rootScope',function(rasService,$rootScope){
	return {
		restrict : 'E',
		templateUrl : 'pages/admin-ras.tpl.html',
		scope : {}, 																						// isolated scope
    controllerAs : 'AdminRasCtrl',
    bindToController: true,
    controller : function (rasService){

    	// variables
    	var self = this;
      self.doingResolveRas1 = false;
      self.doingResolveRas2 = false;
    	self.table = new Array();
    	self.tableYears = new Array();
    	self.years = new Array();
    	self.projNumber = null;
    	self.from = null;
    	self.to = (new Date()).getFullYear();
    	self.fileName = 'ras-matrix';
    	self.showAlert = false;
      self.showAlert2 = false;
      self.dateFrom = null;
      self.dateTo = null;
      self.datePicker1Opened = false;
      self.datePicker2Opened = false;
      self.fileName2 = 'ras-export';
      self.recordType = 'all';
      self.showConfirmation = false;
      // model
      self.newProject = {
        Code: null,
        Name: null,
        Species: null,
        Active: 1,
        ID_RingingScheme: $rootScope.user.rings.scheme
      }

    	for (var i = 2009; i <= (new Date()).getFullYear(); i++){
    		self.years.push(i);
    	}

      rasService.getRasProjects('?where=ID_RingingScheme is \'' + $rootScope.user.rings.scheme + "'")
        .then(function(data){
          self.rasProjects = data;
        });

    	// load data from server
    	self.getRasMatrix = function(){
        self.doingResolveRas1 = true;
    		// load ring order status
	    	rasService.getRasMatrix(self.projNumber, self.from, self.to)
			    .then(function(data){
			    	if (data.length > 0){
			    		for (var i = self.from; i <= self.to; i++){
				    		self.tableYears.push(i);
				    	}
				      self.table = data;
			    	} else {
			    		self.showAlert = true;
			    		self.tableYears = [];
			    		self.table = [];
			    	}
			    	self.doingResolveRas1 = false;
			    }, function(data){
			      alert("Při načítání dat došlo k chybě");
			  });
    	}

      self.insertRasProject = function() {
        rasService.insertRasProject(self.newProject)
          .then(function(data){
            if (!data.error) {
              self.showConfirmation = true;
              self.newProject = {
                Code: null,
                Name: null,
                Species: null,
                Active: 1,
                ID_RingingScheme: $rootScope.user.rings.scheme
              };
              rasService.getRasProjects('?where=ID_RingingScheme is \'' + $rootScope.user.rings.scheme + "'")
                .then(function(data){
                  self.rasProjects = data;
                });
            } else {
              alert('Při ukládání dat došlo k chybě');
            }
          });
      }

      self.getRasData = function(){
        var additionalUrl = "?whereRaw=WHERE obsDate BETWEEN '" + yyyymmdd(self.dateFrom) + "' AND '" + yyyymmdd(self.dateTo) + "'";
        switch (self.recordType){
          case 'all':
            break;
          case 'ringing':
            additionalUrl += ' and ringInformation < 4';
            break;
          case 'retrap':
            additionalUrl += ' and ringInformation > 3';
            break;
        }
        if (self.projNumber2 !== '' && self.projNumber2!=null){
          additionalUrl += ' and projNumber = '+self.projNumber2;
        }
        self.doingResolveRas2 = true;
        rasService.getRasItems(additionalUrl)
          .then(function(data){
            self.rasItems = data;  
            self.doingResolveRas2 = false; 
            if (data.length == 0){
              self.showAlert2 = true;
            }    
          }, function(data){
            alert("Při načítání dat došlo k chybě");
            self.doingResolveRas2 = false;
        });
      }

    	// header of csv file
    	self.getHeader = function(){
    		return ['Code','Sex','Records'];
    	}

    	// export matrix to csv - get data
    	self.exportMatrix = function(){
    		var results = [];
    		for (var i = 0; i<self.table.length; i++){
    			results[i] = {
    				Code: self.table[i]['code'],
    				Sex: self.table[i]['sex'],
    				Records: self.table[i]['years'].join(''),
    			}
    		}
    		return results;
    	}

    }
	}
}])
/*
* directive to display CES records and export them to csv
*/
.directive('adminCes',['rasService','$filter','$rootScope',function(rasService,$filter,$rootScope){
	return {
		restrict : 'E',
		templateUrl : 'pages/admin-ces.tpl.html',
		scope : {}, 																						// isolated scope
    controllerAs : 'AdminCesCtrl',
    bindToController: true,
    controller : function (rasService){

    	// variables
    	var self = this;
      self.doingResolveCes1 = false;
      self.doingResolveCes2 = false;
    	self.table = new Array();
    	self.years = new Array();
    	self.projNumber = null;
    	self.year = null;
    	self.fileName = 'ces-matrix';
    	self.showAlert = false;
      self.showAlert2 = false;
      self.dateFrom = null;
      self.dateTo = null;
      self.datePicker1Opened = false;
      self.datePicker2Opened = false;
      self.fileName2 = 'ces-export';
      self.recordType = 'all';

    	for (var i = 2009; i <= (new Date()).getFullYear(); i++){
    		self.years.push(i);
    	}

      rasService.getCesProjects('?where=ID_RingingScheme is \'' + $rootScope.user.rings.scheme + "'")
        .then(function(data){
          self.cesProjects = data;
        });

      self.getTotal = function(str) {
        var total = 0;
        for(var i = 0; i < self.table.length; i++){
          total += self.table[i][str];
        }
        return total;
      }

    	// load data from server
    	self.getCesMatrix = function(){
        self.doingResolveCes1 = true;
    		// load ring order status
	    	rasService.getCesMatrix(self.projNumber, self.year)
			    .then(function(data){
			    	self.table = data;
            self.doingResolveCes1 = false;
			    	if (data.length == 0){
			    		self.showAlert = true;
			    	}		    	
			    }, function(data){
            self.doingResolveCes1 = false;
			      alert("Při načítání dat došlo k chybě");
			  });
    	}

      self.getCesData = function(){
        additionalUrl = "?whereRaw=projRingingScheme = \'" + $rootScope.user.rings.scheme + "' AND obsDate BETWEEN '" + yyyymmdd(self.dateFrom) + "' AND '" + yyyymmdd(self.dateTo) + "'";
        switch (self.recordType){
          case 'all':
            break;
          case 'ringing':
            additionalUrl += ' and ringInformation < 4';
            break;
          case 'retrap':
            additionalUrl += ' and ringInformation > 3';
            break;
        }
        if (self.projNumber2 !== '' && self.projNumber2!=null){
          additionalUrl += ' and projNumber = '+self.projNumber2;
        }
        self.doingResolveCes2 = true;
        rasService.getCesItems(additionalUrl)
          .then(function(data){
            self.cesItems = data;  
            self.doingResolveCes2 = false; 
            if (data.length == 0){
              self.showAlert2 = true;
            }    
          }, function(data){
            alert("Při načítání dat došlo k chybě");
            self.doingResolveCes2 = false;
        });
      }

    	// header of csv file
    	self.getHeader = function(){
    		return ['Name','1K','Ost'];
    	}

      // header of csv file
      self.getCesItemsHeader = function(){
        return ['Country Identifier','Site Identifier','Site Co-ordinates','Habitat Type','Visit Period','Day','Month','Year','Total Net Length','Visit start time','Visit end time','Ring Scheme','Ring Number','Species','Sex','Age','Brood Patch Score','Moult State','Wing length','Body Mass','Time of weighting','Length P3','Fat Score'];
      }

    	// export matrix to csv - get data
    	self.exportMatrix = function(){
    		return self.table;
    	}

      self.exportCesItems = function(){
        var results = [];
        for (var i = 0; i<self.cesItems.length; i++){
          results[i] = {
            Country: $rootScope.user.rings.scheme,
            Site: self.cesItems[i]['projNumber'],
            crds: $filter('crds')(self.cesItems[i]['lat'],self.cesItems[i]['lng']),
            habitat: self.cesItems[i]['habitat'],
            visit: self.cesItems[i]['checkNumber'],
            day: $filter('amDateFormat')(self.cesItems[i]['obsDate'],'D'),
            month: $filter('amDateFormat')(self.cesItems[i]['obsDate'],'M'),
            year: $filter('amDateFormat')(self.cesItems[i]['obsDate'],'YYYY'),
            netLength: self.cesItems[i]['netLength'],
            start: $filter('hour')(self.cesItems[i]['timeStart']),
            end: $filter('hour')(self.cesItems[i]['timeEnd']),
            scheme: self.cesItems[i]['scheme'],
            ringnumber: self.cesItems[i]['ringNumber'],
            species: self.cesItems[i]['speciesCode'],
            sex: self.cesItems[i]['sex'],
            age: self.cesItems[i]['age'],
            broodPatch: self.cesItems[i]['broodPatch'],
            moult: self.cesItems[i]['moult'],
            wingLength: self.cesItems[i]['wingLength'],
            mass: self.cesItems[i]['mass'],
            weightingTime: self.cesItems[i]['weightingTime'],
            thirdPrimary: self.cesItems[i]['thirdPrimary'],
            fat: self.cesItems[i]['fat']
          }
        }
        return results;
      }

    }
	}
}])
/*
* directive to display history of ring
*/
.directive('stockRingStatus',['ringsService','usersService','$timeout','$rootScope'
  ,function(ringsService,usersService,$timeout,$rootScope){
  return {
    restrict : 'E',
    templateUrl : 'pages/stock-rings-status.tpl.html',
    scope : {},                                             // isolated scope
    controllerAs : 'RingStatusCtrl',
    bindToController: true,
    controller : function ($scope){

      // variables
      var self = this;
      self.showAlert = false;
      self.showSuccessAlert = false;
      self.doingResolve = false;
      // objects
      self.RingType = null;
      self.RingNumber = null;
      self.ring = null;
      self.ringersUrl = 'https://rings.birds.cz/proxy/v1/rings/vw_ringers?where=(ID_RingingScheme is "' + $rootScope.user.rings.scheme + '" or ID_OtherRingingScheme is "' + $rootScope.user.rings.scheme +  '")&s=';

      // load ringtypes
      self.doingResolve = true;
      ringsService.fetchRingTypes (true, $rootScope.user.rings.scheme)
        .then(function(data){
          self.doingResolve = false;
          self.ringTypes = data;
        }, function(data){
          self.doingResolve = false;
          alert(data);
      });

      // load ring status
      ringsService.fetchRingStatus(true)
        .then(function(data){
          self.doingResolve = false;
          self.ringStatus = data;
        }, function(data){
          self.doingResolve = false;
          alert(data);
      });

      self.updateRinger = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
          self.ring.ID_User = null;
          return;
        }
        self.ring.ID_User = selectedValue.originalObject.UID;
      };

      // history - ringing records
      self.searchRingStatus = function(){
        self.doingResolve = true;
        var additionalUrl = "?where=ID_RingType is '"+self.RingType+"' and Number >= "+self.numberFrom +" and Number <="+self.numberTo;
          console.log(additionalUrl);
          ringsService.fetchRingsWithUsers(additionalUrl)
              .then(function(data){
                if (data.length === 0){
                  self.showAlert = true;
                  self.doingResolve = false;
                } else {
                  self.rings = data;
                  self.ring = data[0];
                  self.ring.From = self.numberFrom;
                  self.ring.To = self.numberTo;
                  additionalUrl = "?where=UID is "+self.ring.ID_User;
                  usersService.fetchRingers(additionalUrl)
                    .then(function(data){
                      // anchor
                      $scope.$broadcast('angucomplete-alt:changeInput', 'select-ringer', data[0].Fullname); 
                      self.doingResolve = false;
                    })
                }
              }, function(data){
                self.doingResolve = false;
                alert("Při načítání dat došlo k chybě");
            });
        
      }

      // save changes
      self.changeRingStatus = function(){
        self.doingresolve = true;
        // TODO
        ringsService.editRingsWithUsers(self.ring)
          .then( function( data ) {
            self.doingresolve = true;

            if ( data.ok ) {
              self.showSuccessAlert = true;
            } else {
              alert('Data NEBYLA změněna');
            }
            
          })
      }
    }
  }
} ])
.directive('adminHistory',['ringsService','codebookService','observationService','$rootScope','$timeout','$uibModal','$q','myConfig'
  ,function(ringsService,codebookService,observationService,$rootScope,$timeout,$uibModal,$q,myConfig){
	return {
		restrict : 'E',
		templateUrl : 'pages/admin-history.tpl.html',
		scope : {}, 																						// isolated scope
    controllerAs : 'AdminHistoryCtrl',
    bindToController: true,
    controller : function ($scope){

    	// variables
    	var self = this;
      self.doingResolve = false;
      self.doingResolve2 = false;
    	// ring history
    	self.ringNumber = null;
    	self.scheme = $rootScope.user.rings.scheme;
      self.obceUrl = myConfig[self.scheme].obceUrl;
      self.druhUrl = myConfig[self.scheme].druhUrl;
    	self.showAlert = false;
    	self.history = new Array();
    	// records
    	self.showHistoryAlert = false;
    	self.records = null;
    	self.numRecords = null;
    	self.numRecordsPerPage = 100;
    	self.query = {
    		dateFrom: null,
    		dateTo: null,
        dateCreatedFrom: null,
        dateCreatedTo: null,
    		location: null,
        county: null,
    		species: null,
    		municipality: null,
    		ringInformation: null,
    		ringNumber: null,
        scheme: null,
        seasonFrom: null,
        seasonTo: null,
        sex: null,
        age: null,
        circumstances: null,
        ringType: null,
        yearsFrom: null,
        yearsTo: null
    	};
    	self.order = {
        date: {
          asc: false,
          desc: true
        },
        dateCr: {
          asc: false,
          desc: false
        },
        ringNumber: {
          asc: false,
          desc: false
        },
        species: {
          asc: false,
          desc: false
        },
        station: {
          asc: false,
          desc: false
        },
        sex: {
          asc: false,
          desc: false
        },
        age: {
          asc: false,
          desc: false
        },
        method: {
          asc: false,
          desc: false
        },
        municipality: {
          asc: false,
          desc: false
        },
        owner: {
          asc: false,
          desc: false
        },
        operation: {
          asc: false,
          desc: false
        },
        owner: {
          asc: false,
          desc: false
        }
      };
    	self.seasonRegex = "^(\\d{2}\\.)\\d{2}$"
    	self.ringInformation = [
        {"code": 1,"description": "Kroužek přidán"}
        ,{"code": 4,"description": "Kroužek již přítomný"}
        ,{"code": 6,"description": "Kroužek odstraněn"}];
      self.datePicker1Opened = false;
    	self.datePicker2Opened = false;

    	// load ringing scheme codebook
    	codebookService.fetchCodebook()
	      .then(function(data){
	        self.schemes = data.ringingscheme;
          self.age = data.age;
          self.age.push({Id: 'null', Name: "neznámý"})
          self.primaryidentificationmethod = data.primaryidentificationmethod;
          self.circumstances = data.circumstances;
	      }, function(data){
	        alert(data);
	      });

      // fetch okresy
      codebookService.fetchOkresy(self.scheme.substring(0, 2))
        .then(function(data){
          self.counties = data;          
        }, function(data){
          alert(data);
        });

    	// history - ringing records
		  self.getHistory = function(){
        self.doingResolve = true;
        observationService.fetchObservationHistory(1,self.numRecordsPerPage,self.constructUrl())
          .then(function(data){
            if (data.items.length === 0){
              self.showHistoryAlert = true;
            }
            self.records = data.items;
            self.numRecords = data.rowCount;
            self.doingResolve = false;
          }, function(data){
            self.doingResolve = false;
            alert("Při načítání dat došlo k chybě");
        });
		  }

      // can record be edited?
      self.recordLocked = function(record){
        return record.lastChangeDiff > myConfig.editableTimeLimit;
      }


		  // get class of row
      self.rowClass = function(idOperation){
        switch(idOperation){
          case 1:
            return 'success'
          case 4:
            return 'warning';
          case 6:
            return 'info';
          default:
            return null;
        }
      }

		  // resets order of columns
      self.resetOrder = function(){
        self.order = {
          date: {
            asc: false,
            desc: false
          },
          dateCr: {
            asc: false,
            desc: false
          },
          ringNumber: {
            asc: false,
            desc: false
          },
          species: {
            asc: false,
            desc: false
          },
          station: {
            asc: false,
            desc: false
          },
          sex: {
            asc: false,
            desc: false
          },
          age: {
            asc: false,
            desc: false
          },
          method: {
            asc: false,
            desc: false
          },
          municipality: {
            asc: false,
            desc: false
          },
          owner: {
            asc: false,
            desc: false
          },
          operation: {
            asc: false,
            desc: false
          },
          owner: {
            asc: false,
            desc: false
          }
        }
      }

      self.changeOrder = function(type){
        var asc = self.order[type].asc;
        self.resetOrder();
        if (asc){
          self.order[type].desc = true;
        } else {
          self.order[type].asc = true;
        }
        self.getHistory();
      }

      // allow obsItem to be edited
      self.allowEdit = function(record){
        var dataToSend = {
          DateUpd: 'CURRENT_TIMESTAMP',
          Id: record.obsItemId
        };
        observationService.updateObsItem(dataToSend)
          .then(function(data){
            if (data['ok']){
              record.updated = true;
              $timeout(function(){
                record.updated = false;
              },1000)
            }
          }, function(data){
            alert("Při načítání dat došlo k chybě");
          });
      }

      // open modal window with record detail
      this.showDetail = function(record){
        //self.doingResolve = true;
        self.currentRecord = record;

        var modalScope = $scope.$new();
        
        self.modalInstance = $uibModal.open({
          template: '<admin-history-modal-window record="AdminHistoryCtrl.currentRecord" instance="AdminHistoryCtrl.modalInstance"></admin-history-modal-window>',
          size: 'lg',
          scope: modalScope
        });
        self.doingResolve = false;
      }

      // delete ring item
      self.deleteRecord = function(record){
        var ringnumber = record.ringnumber
        //if (self)
        if(confirm('Opravdu chcete smazat záznam kroužku '+ringnumber+'?')){
          var id = record.ID;
          var newringing = record.idOperationRaw < 4;
          var station = record.station;
          var additionalUrl = '?id='+id+"&ringnumber="+ringnumber+"&ringing="+newringing+"&station="+station;
          observationService.deleteRingItem(additionalUrl).then(
            function(result) {
              if (typeof result.ok === 'undefined' || !result.ok){
                alert("Chyba, nepodařilo se smazat záznam");
              } else {
                alert('Záznam byl úspěšně smazán');
              }
            }
          );
        }
      }

		  // when the page is changed, retrieve data
		  self.pageChanged = function(newPageNumber){
        self.doingResolve = true;
		  	observationService.fetchObservationHistory(newPageNumber,self.numRecordsPerPage,self.constructUrl())
		    .then(function(data){
		      self.records = data.items;
		      self.numRecords = data.rowCount;
          self.doingResolve = false;
		    }, function(data){
		      alert("Při načítání dat došlo k chybě");
          self.doingResolve = false;
		  	});
		  }

		  // adds order to url
      self.constructOrder = function(){
        var url = "&order=";
        if (self.order.date.asc){
          return url +='date asc'
        } else if (self.order.date.desc){
          return url +='date desc'
        } else if (self.order.dateCr.asc){
          return url +='dateCr asc'
        } else if (self.order.dateCr.desc){
          return url +='dateCr desc'
        } else if (self.order.ringNumber.asc){
          return url +='ringnumber asc'
        } else if (self.order.ringNumber.desc){
          return url +='ringnumber desc'
        } else if (self.order.species.asc){
          return url +='species asc'
        } else if (self.order.species.desc){
          return url +='species desc'
        } else if (self.order.station.asc){
          return url +='station asc'
        } else if (self.order.station.desc){
          return url +='station desc'
        } else if (self.order.sex.asc){
          return url +='sex asc'
        } else if (self.order.sex.desc){
          return url +='sex desc'
        } else if (self.order.age.asc){
          return url +='ageId asc'
        } else if (self.order.age.desc){
          return url +='ageId desc'
        } else if (self.order.method.asc){
          return url +='methodName asc'
        } else if (self.order.method.desc){
          return url +='methodName desc'
        } else if (self.order.operation.asc){
          return url +='operation asc'
        } else if (self.order.operation.desc){
          return url +='operation desc'
        } else if (self.order.municipality.asc){
          return url +='municipality asc'
        } else if (self.order.municipality.desc){
          return url +='municipality desc'
        } else if (self.order.owner.asc){
          return url +='ownerName asc'
        } else if (self.order.owner.desc){
          return url +='ownerName desc'
        }
        return "";
      }

		  // created additional url string to be passed to service
		  self.constructUrl = function(){
		  	var url = "";
        var whereRaw = '';
        // add date, if set
		  	if ((self.query.dateFrom != null && self.query.dateFrom != '')
		  		|| (self.query.dateTo != null && self.query.dateTo != '')){
		  		var dateFrom = '1000-01-01';
		  		var dateTo = '9999-12-31';
		  		if (self.query.dateFrom != null && self.query.dateFrom != ''){
		  			var dateFrom = yyyymmdd(self.query.dateFrom);
		  		}
		  		if (self.query.dateTo != null && self.query.dateTo != ''){
		  			var dateTo = yyyymmdd(self.query.dateTo);
		  		}
		  		url += " and date between '"  + dateFrom + "' and '" + dateTo + "'";
		  	}
        // add date created, if set
        if ((self.query.dateCreatedFrom != null && self.query.dateFreatedFrom != '')
          || (self.query.dateCreatedTo != null && self.query.dateCreatedTo != '')){
          var dateCreatedFrom = '1000-01-01';
          var dateCreatedTo = '9999-12-31';
          if (self.query.dateCreatedFrom != null && self.query.dateCreatedFrom != ''){
            var dateCreatedFrom = yyyymmdd(self.query.dateCreatedFrom);
          }
          if (self.query.dateCreatedTo != null && self.query.dateCreatedTo != ''){
            var dateCreatedTo = yyyymmdd(self.query.dateCreatedTo);
          }
          url += " and dateCr between '"  + dateCreatedFrom + "' and '" + dateCreatedTo + "'";
        }
		  	// licence number
		  	if (self.query.licenceNumber != null && self.query.licenceNumber != ''){
		  		url += " and licenceNumber is '"  + self.query.licenceNumber + "'";
		  	}
		  	// owner
		  	if (self.query.owner != null && self.query.owner != ''){
		  		url += " and ownerName like '%"  + self.query.owner + "%'";
		  	}
		  	// species
		  	if (self.query.species != null){
		  		// taxonomic tree
		  		if (self.query.species.GenusId !== 0){
		  			url += " and taxonid is " + self.query.species.TaxonID;
		  		} else if (self.query.species.FamilyId !== 0){
		  			url += " and genusid is " + self.query.species.TaxonID;
		  		} else if (self.query.species.OrderId !== 0){
		  			url += " and familyid is " + self.query.species.TaxonID;
		  		} else {
		  			url += " and orderid is " + self.query.species.TaxonID;
		  		}
		  	}
		  	// municipality
		  	if (self.query.municipality != null){
		  		url += " and kodcobe is " + self.query.municipality;
		  	}
        // county
        if (self.query.county != null){
          url += " and county is '" + self.query.county + "'";
        }
        // age
        if (self.query.age != null){
          if (self.query.age == 'null') {
            url += " and ageId isnull";
          } else {
            url += " and ageId is '" + self.query.age + "'";
          }          
        }
        // sex
        if (self.query.sex != null){
          url += " and sexId is '" + self.query.sex + "'";
        }
		  	// ring operation
		  	if (self.query.ringInformation != null){
          var key = self.query.additionalMark ? 'mrkIdOperation' : 'idOperationRaw';
          if (self.query.ringInformation === 1){
            url += " and "+key+" < 4";
          } else {
            url += " and "+key+" is " + self.query.ringInformation;
          }
		  	}
        // circumstances
        if (self.query.circumstances) {
          url += " and circumstances is '" + self.query.circumstances + "'";
        }
        // ringing scheme
        if (self.query.scheme != null && self.query.scheme != ''){
          var key = self.query.additionalMark ? 'mrkStation' : 'station';
          url += " and "+key+" is '"  + self.query.scheme + "'";
        }
        // ring type
        if (self.query.ringType != null){
          var key = self.query.additionalMark ? 'mrkMarkType' : 'markType';
          url += " and "+key+" is '" + self.query.ringType + "'";
        }
		  	// ringnumber
		  	if (self.query.ringNumber != null && self.query.ringNumber != ''){
          // ringnumber
          if (self.query.ringNumber != null){
            var key = self.query.additionalMark ? 'mrkRingnumber' : 'ringnumber';
            var rn = self.query.ringNumber.replace(/\s/g,'');
            url += " and "+key+" is '" + rn + "'";
            /*var fullrn = fullRingNumber(rn);
            if (fullrn == rn || fullrn === null){
              url += " and "+key+" is '" + rn + "'";
            } else {
              url += " and ("+key+" is '" + rn + "' or "+key+" is '" + fullrn + "')";
            }*/
          }
		  	}
        // projects
        if(self.query.ces){
          url += " and ces is 1";
        }
        if(self.query.ras){
          url += " and ras is 1";
        }
        // season
        if (self.query.seasonFrom != null && self.query.seasonTo != null){
          var regexPattern = /^([0-9]{1,2})\.([0-9]{1,2})?$/i;
          var matchFrom = regexPattern.exec(self.query.seasonFrom);
          var mFrom = matchFrom[2];
          var dFrom = matchFrom[1];
          var matchTo = regexPattern.exec(self.query.seasonTo);
          var mTo = matchTo[2];
          var dTo = matchTo[1];
          var strFrom = ("0" + mFrom).slice (-2) + '' + ("0" + dFrom).slice (-2);
          var strTo = ("0" + mTo).slice (-2) + '' + ("0" + dTo).slice (-2);
          if (strFrom > strTo){
            whereRaw += "AND DATE_FORMAT(date, '%m%d') > " + strFrom + " OR DATE_FORMAT(date, '%m%d') < " + strTo + ' ';
          } else {
            whereRaw += "AND DATE_FORMAT(date, '%m%d') BETWEEN " + strFrom + " AND " + strTo + ' ';
          }
        }
        if (self.query.yearsFrom != null && self.query.yearsTo != null){
          whereRaw += "AND YEAR(date) BETWEEN " + self.query.yearsFrom + " AND " +  self.query.yearsTo;
        }
        if (whereRaw.length > 0){
          url += "&whereRaw=" + encodeURI(whereRaw);
        }
        url = url.replace(/^( and )/,"");
        url = "scheme="+$rootScope.user.rings.scheme+"&where="+url;
        url += self.constructOrder();
		  	return encodeURI(url);
		  }

    	// open datepicker
    	self.openDatePicker = function(val){
		  	let param = 'datePicker' + val + 'Opened';
        self[param] = true;
		  }

    	// when autocompleter option for species is selected, update model
    	this.updateSpecies = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
          self.query.species = null;
          return;
        }
        self.query.species = selectedValue.originalObject; 
    	};

    	// when autocompleter option for municipality is selected, update model
    	this.updateMunicipality = function (selectedValue) {
    		if (!selectedValue) {
          self.query.municipality = null;
          return;
        }
        if (selectedValue) {
          self.query.municipality = selectedValue.originalObject.ID;
        }
    	};

    	// reset all form options
  		self.resetForm = function(){
  		  self.query = {
          dateFrom: null,
          dateTo: null,
          location: null,
          county: null,
          species: null,
          municipality: null,
          ringInformation: null,
          ringNumber: null,
          scheme: null,
          seasonFrom: null,
          seasonTo: null,
          sex: null,
          age: null,
          circumstances: null,
          ringType: null,
          yearsFrom: null,
          yearsTo: null
        };
  	   	// reset autocompleter
  	   	$rootScope.$broadcast('angucomplete-alt:clearInput');
  		}

      self.coordinates = function( value, lon ) {
        var output = ''
        // degrees
        if (value < 0) {
          output += '-'
        } else {
          output += '+'
        }
        // degrees
        var deg = ('000' + Math.floor(value)).slice (lon ? -3 : -2);
        output += deg;
        // minutes
        var min = Math.floor((value - Math.floor(value)) * 60);
        var min = ('00' + min).slice (-2);
        output += min;
        // seconds
        var sec = Math.floor((((value - Math.floor(value)) * 60) - min)*60);
        var sec = ('00' + sec).slice (-2);
        output += sec;
        return output;
      }

      // header of csv file
      self.getHeader = function(){
        /*return ['Datum','Číslo kroužku','Stanice','Druh','Druh(lat)','Info','Typ značky','Lokalita'
        ,'X','Y','Obec','Okres','Region','Zaznamenal','Kód kroužkovatele','Věk','Pohlaví','Délka sítě'
        ,'CES lokalita','CES kontrola','CES pelichání','Čas vážení','Hmotnost','Tuk','Délka křídla'
        ,'Kód druhu','EURING','souřadnice'];*/
        return ['Datum','Číslo kroužku','Délka sítí','Stanice','Druh','Druh(lat)'
        ,'Info','Typ značky','Lokalita','X','Y','Obec','Okres','Region'
        ,'Poznámka lok.','Poznámka','Věk','Pohlaví',"Návnada","Metoda odchytu","Manipulace","Status"
        ,'Kondice','Okolnosti','Délka křídla','Třetí ruční letka','Stav vrcholu křídla','Hmotnost','Čas vážení'
        ,'Pelichání','Šat','Zadní dráp','Délka zobáku','Metoda měření zobáku','Délka hlavy','Tarsus','Metoda měření tarsu'
        ,'Délka ocase','Rozdíl délky RP','Tuk','Prsní svaly',"Věk pull.","Přesnost věku pull.",'Hnízdní nažina','Holina','Staré LK'
        ,'Zápěstní krovka','Pelichání RL','Pelichání LL','Alula',"Typ př. značky","Info př. značky","Barva př. značky"
        ,"Stanice př. značky","Číslo př. značky","CES","Projekt CES","Kontrola CES","Č. sítě CES"
        ,"Délka sítě CES","Pelichání CES","Habitat CES","Čas vážení CES"
        ,"RAS","Projekt RAS","Kontrola RAS","Trvání RAS"
        ,"ID Rodiny","Role","Mláďat v hnízdě","Č.budky/hnízda","Kippův index","Mlynařík hlava"];
      }

      self.getColumns = function(){
      /*return ['date','ringnumber','station','species','speciesLat','operation','methodName','locality'
        ,'lon','lat','municipality','countyCode','place','ownerName','licenceNumber','age','sex','netLength'
        ,'cesProjNumber','cesCheckNumber','cesMoult','measurementTime','mass','fat','wingLength','euringCode'
        ,'crds'];*/
        return ['dateExport','ringnumber','netLength','station','species','speciesLat'
        ,'operation','methodName','locality','Longitude','Latitude','municipality','okres','place'
        ,'siteNote','note','age','sex',"catchingLure","catchingMethod","manipulated","status"
        ,'cond','circumstances','wingLength','thirdPrimary','stateOfWingPoint','mass','measurementTime'
        ,'moult','plumageCode','hindClaw','billLength','billMethod','totalHeadLength','tarsus','tarsusMethod'
        ,'tailLength','tailDifference','fatScore','pectoralMuscleScore',"pullusAge","pullusAccuracy",'broodPatch','juvenilePatch','oldGreatedCoverts'
        ,'carpalCoverts','primaryMoult','secondaryMoult','alula',"mrkMarkType","mrkIdOperation","mrkColor"
        ,"mrkStation","mrkRingnumber","ces","cesProjNumber","cesCheckNumber","cesNetNumber"
        ,"cesNetLength","cesCesMoult","cesCesHabitat","cesWeightingTime"
        ,"ras","rasProjNumber","rasCheckNumber","rasCheckDuration"
        ,"ringFamilyId","familyRole","numBirds","nestNumber","kipp","aegithalosMask"];
      }

      // export table as csv
      self.exportCsv = function(){
        //return self.records;   
        //observationService.fetchObservationHistory(1,self.numRecords,self.constructUrl())
        observationService.fetchFullObservationOverview(self.constructUrl()+'&save=true')
          .then(function(data){
            window.open("https://rings.birds.cz/userdata/rings/export/export.csv", "_blank")
            //return(data.items);
          }, function(data){
            alert("Při načítání dat došlo k chybě");
            self.doingResolve = false;
          });
      }


    }
	}
}	])
/*user detail modal window*/
.directive('adminHistoryModalWindow',['$rootScope','observationService','codebookService','rasService','amMoment','$timeout','myConfig'
  ,function($rootScope,observationService,codebookService,rasService,amMoment,$timeout,myConfig){
  return {
    restrict : 'E',
    templateUrl : 'templates/history-modal.tpl.html',
    scope : { 
      record : '=',
      instance: "="
    },
    controllerAs : 'ModalHistoryCtrl',
    bindToController: true,
    controller : function ($scope){

      var self = this;
      // gui
      self.headerEdited = false;
      self.detailEdited = true;
      self.datePickerOpened = false;
      
      // data
      self.id = null,
      self.date = null;
      self.timeFrom = new hhmm();
      self.timeTo = new hhmm();
      self.note = null;
      self.country = null;
      self.locality = new Locality();
      self.scheme = $rootScope.user.rings.scheme;
      self.obceUrl = myConfig[self.scheme].obceUrl;
      self.druhUrl = myConfig[self.scheme].druhUrl;
      self.detail = new Observation(self.scheme);
      // map
      self.mapOption = myConfig[self.scheme].mapOption;
      self.supportedFormatsTpl = "Podporované formáty:<ul><li>48.255757N, 17.597398E</li><li>N 50&deg;2.96520&rsquo;, E 14&deg;30.58850&rsquo;</li><li>39º17'00''N 03º14'00''W</li><li>39 41 45N 03 14 00W</li><li>50&deg;4&rsquo;49.008&rdquo;N, 14&deg;24&rsquo;37.656&rdquo;E</li></ul>";

      self.ringInformation = [
        {"code": 1,"description": "Nové kroužkování"}
        ,{"code": 4,"description": "Kroužek již přítomen"}
        ,{"code": 6,"description": "Odstranění kroužku"}];

      // load codebook
      self.doingResolve = true;
      codebookService.fetchCodebook()
        .then(function(data){
          self.codebook = data;
          observationService.getObsItem(self.record.ID)
            .then(function(data){
              self.construct(data[0]);
              self.doingResolve = false;
            });
        }, function(data){
          alert(data);
        });

      rasService.getRasProjects()
        .then(function(data){
          self.rasProjects = data;
        });

      rasService.getCesProjects()
        .then(function(data){          
          self.cesProjects = data;
        });

      self.updateRinger = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
          self.owner = (self.scheme === 'CZP' ? 'krouzkovaci_stanice' : 'bratislava');
          //self.owner = 'krouzkovaci_stanice';
          return;
        }
        self.owner = selectedValue.originalObject.owner;
      };

      self.construct = function(record){
        // fill object with data
        self.id = record.obsListsId;
        self.detail.scheme = self.scheme;
        self.detail.id = record.ringItemId;
        self.detail.obsListId = record.obsListsId;
        self.date = new Date(record.date);
        // strip seconds from time
        self.timeFrom = new hhmm();
        self.timeTo = new hhmm();
        self.timeFrom.time = (record.timeFrom == null) ? null : record.timeFrom.substring(0,5);
        self.timeTo.time = (record.timeTo == null) ? null : record.timeTo.substring(0,5);
        self.note = record.note;
        self.coobservers = record.coobservers;
        self.ownerName = record.ownerName;
        self.owner = record.owner;
        self.locality.Name = record.locality;
        self.locality.Municipality = record.nazcobe; 
        $scope.$broadcast('angucomplete-alt:changeInput', 'select-municipality-history', self.locality.Municipality); 
        self.locality.KODCOBE = record.kodcobe;  
        self.locality.ID_MunicipalityPart = record.municipalityId;
        self.locality.coords.latitude = record.latitude;
        self.locality.coords.longitude = record.longitude;  
        self.mapOption.lat = record.latitude;
        self.mapOption.lng = record.longitude;
        self.locality.crdsText = self.locality.coords.latitude + ', ' + self.locality.coords.longitude;
        self.locality.Note = record.siteNote;
        // age, sex
        self.detail.sex = (record.sex == null) ? null : record.sex.toString();
        self.detail.age = record.age; 
        // scheme
        self.detail.ringingScheme = record.scheme;
        // set ring information, including additional ring information
        if (typeof record.species !== 'undefined'){
          self.detail.species = record.species;
        }
        // set additional marks
        if (typeof record.additionalMarks !== 'undefined'){
          self.detail.additionalMarks = record.additionalMarks;
        }
        if (record.ringInformation == 2 || record.ringInformation == 3){
          self.detail.additionalRingInformation = record.ringInformation;
        } else if (record.ringInformation > 3) {
          self.detail.ringInformation = record.ringInformation;
        }
        // date last change
        /*if (typeof record.lastChange !== 'undefined' && record.lastChange !== null){
          self.detail.lastChange = new Date(record.lastChange);
        }
        // date last change
        if (typeof record.lastChangeDiff !== 'undefined' && record.lastChangeDiff !== null){
          self.detail.lastChangeDiff = new Date(record.lastChangeDiff);
        }*/
        // set ring numbers
        self.detail.ringNumber1_retrap = record.ringNumber;
        self.detail.markType = record.markType;
        self.detail.markColor = record.markColor;
        self.detail.placeCode = record.placeCode;
        var country = self.codebook.placecode.filter(x => x.Code === self.detail.placeCode)[0];
        if (country) {
          self.country = country.Country;  
        }        
        self.detail.sexingMethod = record.sexingMethod;
        self.detail.catchingMethod = record.catchingMethod;
        self.detail.catchingLure = record.catchingLure;
        self.detail.circumstances = record.circumstances;
        self.detail.circumstancesPresumed = (record.circumstancesPresumed == 1) ? true : false;
        self.detail.condition = record.cond;
        self.detail.status = record.status;
        self.detail.manipulated = record.manipulated;
        self.detail.movedBeforeEncounter = record.movedBeforeEncounter;
        self.detail.pullusAge = (record.pullusAge == 99) ? null : record.pullusAge;
        self.detail.pullusAccuracy = record.pullusAccuracy;
        self.detail.dateAccuracy = record.dateAccuracy;
        self.detail.coordinatesAccuracy = record.coordinatesAccuracy;
        self.detail.netLength = record.netLength;
        self.detail.verifiedByScheme = (record.verifiedByScheme == 1) ? true : false;
        self.detail.note = record.detailNote;
        self.detail.photoId = record.photoId;
        self.detail.photoName = record.photoName;
        if (self.detail.photoName){
          self.detail.photoPath = '/userdata/images/'+self.detail.photoName+'.jpg';
        }
        self.detail.wingLength = record.wingLength;
        self.detail.thirdPrimary = record.thirdPrimary;
        self.detail.mass = record.mass;
        self.detail.time = (record.measurementTime == null || record.measurementTime == '') ? null : record.measurementTime.substring(0,5);
        self.detail.hindClaw = record.hindClaw;
        self.detail.billLength = record.billLength;
        self.detail.billMethod = record.billMethod;
        self.detail.totalHeadLength = record.totalHeadLength;
        self.detail.tarsus = record.tarsus;
        self.detail.tarsusMethod = record.tarsusMethod;
        self.detail.tailLength = record.tailLength;
        self.detail.tailDifference = record.tailDifference;
        self.detail.firstLLLength = record.firstLLLength;
        self.detail.rPExtensionLength = record.rPExtensionLength;
        self.detail.secondRLNotchLength = record.secondRLNotchLength;
        self.detail.stateOfWingPoint = record.stateOfWingPoint;
        self.detail.moult = record.moult;
        self.detail.plumageCode = record.plumageCode;
        self.detail.fat = record.fatScore;
        self.detail.pectoralMuscleScore = record.pectoralMuscleScore;
        self.detail.broodPatch = record.broodPatch;
        self.detail.ringedLeg = (record.ringedLeg === null) ? '' : record.ringedLeg.toString();       
        self.detail.juvenilePatch = (record.juvenilePatch === null) ? '' : record.juvenilePatch.toString();
        self.detail.oldGreaterCoverts = (record.oldGreaterCoverts === null) ? '' : record.oldGreaterCoverts.toString();
        self.detail.carpalCovert = (record.carpalCovert === null) ? '' : record.carpalCovert.toString();
        if (typeof record.primaryMoult !== 'undefined' && record.primaryMoult != null && record.primaryMoult.length == 10){
          self.detail.primaryMoult.v1 = record.primaryMoult.substring(0,1);
          self.detail.primaryMoult.v2 = record.primaryMoult.substring(1,2);
          self.detail.primaryMoult.v3 = record.primaryMoult.substring(2,3);
          self.detail.primaryMoult.v4 = record.primaryMoult.substring(3,4);
          self.detail.primaryMoult.v5 = record.primaryMoult.substring(4,5);
          self.detail.primaryMoult.v6 = record.primaryMoult.substring(5,6);
          self.detail.primaryMoult.v7 = record.primaryMoult.substring(6,7);
          self.detail.primaryMoult.v8 = record.primaryMoult.substring(7,8);
          self.detail.primaryMoult.v9 = record.primaryMoult.substring(8,9);
          self.detail.primaryMoult.v10 = record.primaryMoult.substring(9,10);
        }
        if (typeof record.secondaryMoult !== 'undefined' && record.secondaryMoult != null && record.secondaryMoult.length == 6){
          self.detail.secondaryMoult.v1 = record.secondaryMoult.substring(0,1);
          self.detail.secondaryMoult.v2 = record.secondaryMoult.substring(1,2);
          self.detail.secondaryMoult.v3 = record.secondaryMoult.substring(2,3);
          self.detail.secondaryMoult.v4 = record.secondaryMoult.substring(3,4);
          self.detail.secondaryMoult.v5 = record.secondaryMoult.substring(4,5);
          self.detail.secondaryMoult.v6 = record.secondaryMoult.substring(5,6);
        }
        if (typeof record.alula !== 'undefined' && record.alula != null && record.alula.length == 3){
          self.detail.alula.v1 = record.alula.substring(0,1);
          self.detail.alula.v2 = record.alula.substring(1,2);
          self.detail.alula.v3 = record.alula.substring(2,3);
        }
        self.detail.bloodSample = (record.bloodSample == 1);
        self.detail.featherSample = (record.featherSample == 1);
        // family info
        self.detail.family = new Family();
        self.detail.family.NumBirds = parseInt(record.broodSize);
        if (record.ringFamilyId != null){
          self.detail.family.ID = record.ringFamilyId;
          self.detail.family.itemId = record.ringFamilyItemId;
          self.detail.family.Description = record.ringFamilyDescription;
          self.detail.family.Closed = parseInt(record.ringFamilyClosed) == 1;
          self.detail.family.role = record.role;
          self.detail.family.ringed = record.ringed;
          self.detail.family.NumBirds = parseInt(record.numBirds);
        }   
        // ras
        if (record.ras != null && record.ras.length != 0){
          self.detail.ras = true;
          self.detail.rasProjNumber = record.ras[0].ProjNumber
          self.detail.rasCheckNumber = record.ras[0].CheckNumber;
          self.detail.rasDuration = record.ras[0].CheckDuration;
        } 
        // ces      
        if (record.ces != null && record.ces.length != 0){
          self.detail.ces = true;
          self.detail.cesProjNumber = record.ces[0].ProjNumber
          self.detail.cesCheckNumber = record.ces[0].CheckNumber;
          self.detail.cesNetNumber = record.ces[0].NetNumber;
          self.detail.cesNetLength = record.ces[0].NetLength;
          self.detail.cesMoult = record.ces[0].ID_CesMoult;
          self.detail.cesHabitat = record.ces[0].ID_CesHabitat;
          self.detail.cesWeightingTime = (record.ces[0].WeightingTime == null || record.ces[0].WeightingTime == '') ? null : record.ces[0].WeightingTime.substring(0,5);
        }
      }

      // when autocompleter option is selected, update model
      this.updateSpecies = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
            self.detail.species = {TaxonID: null,Name:null,Fullname:null,isWader:null};
            return;
        }
        self.detail.species = selectedValue.originalObject; 
        self.detail.speciesUnknown = false;
      };

      this.speciesUnknown = function(){
        if (self.detail.speciesUnknown){
          $rootScope.$broadcast('angucomplete-alt:clearInput');
        }
      }

      self.filterCircumstances = function() {
        return function( item ) {
          return item.Code.indexOf('P') !== 0;
        };
      };

      this.updatePlaceCode = function(){
        var country = self.codebook.placecode.filter(x => x.Country === self.country);
        if (country.length){
          self.placeCode = country[0].Code;
        } else {
          self.placeCode = null;
        }
      }

      // if ringtype is changed to metal ring, set color to null
      this.markTypeChanged = function() {
        if (self.detail.markType === 'A0') {
          self.detail.markColor = null;
        }
      };

      // validation of detail
      this.validateDetail = function(){
        // validate ringOperation - not necessary, can not be edited
        /*if (self.detail.ringInformation == null){
          alert('Typ operace musí být vyplněn');
          return false;
        }
        // validate ringingScheme
        if (self.detail.markType == 'A0' && self.detail.ringingScheme == null){
          alert('Stanice musí být vyplněna');
          return false;
        }
        if ((self.detail.ringInformation == 1 && self.detail.ringingScheme != 'CZP')){
          alert('Nelze kroužkovat kroužky z jiné stanice než Praha');
          return false;
        }*/

        // validate mark color - main identification mark
        if (['B0','C0','D0','H0'].indexOf(self.detail.markType) != -1
          && self.detail.markColor == null){
          alert('Barva musí být vyplněna');
          return false;
        }
        // validate mark color of additional marks
        /*for (var i = 0; i < self.detail.additionalMarks.length; i++){
          var mark = self.detail.additionalMarks[i];
          if (['B0','C0','D0','H0'].indexOf(mark.markType) != -1
            && mark.markColor == null){
            alert('Barva přídatné identifikační značky musí být vyplněna');
            return false;
          } 
        }*/
        // validate additional marks
        for (var i = 0; i < self.detail.additionalMarks.length; i++){
          var mark = self.detail.additionalMarks[i];
          if (!mark.ringInformation) {
            alert('Úkon přídatné identifikační značky musí být vyplněn');
            return false;
          }
          if (!mark.markType) {
            alert('Typ přídatné identifikační značky musí být vyplněn');
            return false;
          } 
          if (!mark.ringNumber_retrap) {
            alert('Kód přídatné identifikační značky musí být vyplněn');
            return false;
          } 
        }
        // validate sex
        if (self.detail.sex == null){
          alert('Pohlaví musí být vyplněno');
          return false;
        }
        // validate age
        if (self.detail.age == null && self.detail.ringInformation != 4){
          alert('Věk musí být vyplněn. Pokud si nejste jistí přesným věkem, vyplňte jen, zda se jednalo o pullus nebo dospělého jedince');
          return false;
        }
        // validate species
        if ((self.detail.species == null || self.detail.species.TaxonID == null) && self.detail.ringInformation != 4){
          alert('Druh musí být vyplněn. Vyberte ze seznamu, nikoli vepsáním názvu do textového pole');
          return false;
        }
        // validate ring number - not necessary, can not be edited
        // new ring
        /*if (['A0','C0'].indexOf(self.detail.markType) !== -1){
          if (self.detail.ringInformation == 1){
            if (self.detail.ringType1 == null || self.detail.ringNumber1 == null){
              alert('Musí být vyplněno číslo kroužku');
              return false;
            }
          // re-ringing
          } else {
            if (self.detail.ringNumber1_retrap == null || self.detail.ringNumber1_retrap.length == 0){
              alert('Musí být vyplněno číslo kroužku');
              return false;
            }
          }
        }*/
        
        // additional information
        // circumstances are required for retrap
        if (self.detail.ringInformation > 3 && self.detail.circumstances == null){
          alert('Pole "Okolnosti" je povinné, pokud se jedná o zpětný odchyt');
          return false;
        }
        // circumstances
        if (self.detail.circumstances != null 
            && !isNumber(self.detail.circumstances)){
          alert('Neplatná hodnota pole "Okolnosti"');
          return false;
        } else if (parseFloat(self.detail.circumstances) < 0 || parseFloat(self.detail.circumstances) > 99){
          alert('Neplatná hodnota pole "Okolnosti"');
          return false;
        }

        // biometrics
        // wing length
        if (self.detail.wingLength != null && self.detail.wingLength != ''
            && (!isNumber(self.detail.wingLength) || parseFloat(self.detail.wingLength) < 0)){
          alert('Neplatná hodnota pole "Délka křídla"');
          return false;
        }
        // thirdPrimary
        if (self.detail.thirdPrimary != null && self.detail.thirdPrimary != ''
            && (!isNumber(self.detail.thirdPrimary) || parseFloat(self.detail.thirdPrimary) < 0)){
          alert('Neplatná hodnota pole "Třetí ruční letka"');
          return false;
        }
        // mass
        if (self.detail.mass != null && self.detail.mass != ''
          && (!isNumber(self.detail.mass) || parseFloat(self.detail.mass) < 0)){
          alert('Neplatná hodnota pole "Hmotnost"');
          return false;
        }
        // time of measurement
        if (self.detail.time != null && self.detail.time != ''){
          var regexPattern = /^([0-9]|0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9])?$/i;
          if (!regexPattern.test(self.detail.time)){
            alert('Hodnota "Čas odchytu" má nesprávný formát');
            return false;
          }
        }     
        // tces weighting time
        if (self.detail.cesWeightingTime != null && self.detail.cesWeightingTime != ''){
          var regexPattern = /^([0-9]|0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9])?$/i;
          if (!regexPattern.test(self.detail.cesWeightingTime)){
            alert('Hodnota "Čas vážení" má nesprávný formát');
            return false;
          }
        } 
        // hindClaw
        if (self.detail.hindClaw != null 
            && (!isNumber(self.detail.hindClaw) || parseFloat(self.detail.hindClaw) < 0)){
          alert('Neplatná hodnota pole "Zadní dráp"');
          return false;
        }
        // billLength
        if (self.detail.billLength != null 
            && (!isNumber(self.detail.billLength) || parseFloat(self.detail.billLength) < 0)){
          alert('Neplatná hodnota pole "Délka zobáku"');
          return false;
        }
        // bill method
        /*if (self.detail.billLength != null && self.detail.billLength > 0 && self.detail.billMethod == null){
          alert('Pole "metoda měření zobáku" je povinné, pokud je vyplněna délka zobáku');
          return false;
        }*/
        // totalHeadLength
        if (self.detail.totalHeadLength != null 
            && (!isNumber(self.detail.totalHeadLength) || parseFloat(self.detail.totalHeadLength) < 0)){
          alert('Neplatná hodnota pole "Délka hlavy"');
          return false;
        }
        // totalHeadLength
        if (self.detail.tarsus != null && self.detail.tarsus != ''
          && (!isNumber(self.detail.tarsus) || parseFloat(self.detail.tarsus) < 0)){
          alert('Neplatná hodnota pole "Délka tarsu"');
          return false;
        }
        // tarsusMethod
        /*if (self.detail.tarsus != null && self.detail.tarsus > 0 && self.detail.tarsusMethod == null){
          alert('Pole "metoda měření tarsu" je povinné, pokud je vyplněna délka tarsu');
          return false;
        }*/
        // tailLength
        if (self.detail.tailLength != null 
          && (!isNumber(self.detail.tailLength) || parseFloat(self.detail.tailLength) < 0)){
          alert('Neplatná hodnota pole "Délka ocasu"');
          return false;
        }
        // tailDifference
        if (self.detail.tailDifference != null 
            && (!isNumber(self.detail.tailDifference) || parseFloat(self.detail.tailDifference) < 0)){
          alert('Neplatná hodnota pole "rozdíl délky RP"');
          return false;
        }
        // old greater coverts
        if (self.detail.oldGreaterCoverts !== null && self.detail.oldGreaterCoverts !== ''
            && (!isNumber(self.detail.oldGreaterCoverts) || parseFloat(self.detail.oldGreaterCoverts) < 0)){
          alert('Neplatná hodnota pole "oldGreaterCoverts"');
          return false;
        }

        return true;
      }

      // save to DB
      this.saveDetail = function(close,copy){
        if (self.validateDetail()){
          self.detail.obsListId = self.id;
          // ras, ces
          /*if (self.detail.cesProjNumber) {
            self.detail.ces = true;
          } else {
            self.detail.ces = false;
          }
          if (self.detail.rasProjNumber) {
            self.detail.ras = true;
          } else {
            self.detail.ras = false;
          }*/
          var dataToSend = angular.copy(self.detail);
          dataToSend['user'] = $rootScope.user;   
          //dataToSend['close'] = close;
          //dataToSend['copy'] = copy;
          //dataToSend['date'] = self.date;
          self.send(dataToSend);
        }
      }

      this.addMark = function() {
        var newMark = {
          additionalRingInformation: null,
          markColor: null,
          markType: null,
          ringInformation: null,
          ringItemId: self.detail.id,
          ringNumber_retrap: null,
          ringingScheme: null
        }
        this.detail.additionalMarks.push(newMark);
      }

      this.deleteMark = function(mark) {
        if (mark.id) {
          observationService.deleteMark(mark.id)
            .then(function(response) {
              if (response.ok) {
                var index = self.detail.additionalMarks.findIndex(obj => obj.id === mark.id);
                var newData = [
                    ...self.detail.additionalMarks.slice(0, index),
                    ...self.detail.additionalMarks.slice(index + 1)
                ]
                self.detail.additionalMarks = newData;
              }
            });
        }        
      }

      // send
      this.send = function(dataToSend){
        self.doingSavingResolve = true;
        observationService.sendAdminItem(dataToSend).then(
          function(result) {
            if (typeof result.error !== 'undefined'){
              switch (result.error) {
                case "RING_NOT_AVAILABLE":
                  alert("Vybraný kroužek není k dispozici");
                  self.doingSavingResolve = false;
                  break;
                default:
                  alert("Chyba: " + result.error);
                  self.doingSavingResolve = false;
                  break;
              }     
            } else if (typeof result.warning !== 'undefined'){
              if (confirm("U daného kroužku a dne jste již zaznamenal/a zpětný odchyt, chcete přesto uložit?")){
                dataToSend['ignoreWarning'] = true;
                self.send(dataToSend);
              }                 
            } else if (typeof result.id !== 'undefined'){

              self.showAlert=true;
                  
            } else {
              alert("Neznámá chyba: " + JSON.stringify(result));
            }
          }
        );
      }

      // parses text and retrieves coordinates from it
      this.updateCrds = function(){
        if (self.locality.crdsText == null || self.locality.crdsText == ''){
          self.locality.err = false;
          return;
        }
        // example 48.255757N, 17.597398E
        var regexPattern1 = /^([0-9]{1,2}\.[0-9]*)[N,S]?, ([0-9]{1,2}\.[0-9]*)[E,W]?$/i;
        // example 50°4'49.008"N, 14°24'37.656"E
        var regexPattern2 = /^([0-9]{1,2})°([0-9]{1,2})'([0-9]{1,2}\.?[0-9]+?)"[N,S]?, ([0-9]{1,2})°([0-9]{1,2})'([0-9]{1,2}\.?[0-9]+?)"[E,W]?$/i;
        // example N 50°2.96520', E 14°30.58850'
        var regexPattern3 = /^[N,S] ([0-9]{1,2})°([0-9]{1,2}\.[0-9]+)', [E,W] ([0-9]{1,2})°([0-9]{1,2}\.[0-9]+)'$/i
        // example 39º17'00''N 03º14'00''W
        var regexPattern4 = /^([0-9]{1,2})º([0-9]{1,2})'([0-9]{2})''[N,S] ([0-9]{1,2})º([0-9]{1,2})'([0-9]{2})''[E,W]$/i
        // example 39 17 00N 03 14 00W
        var regexPattern5 = /^([0-9]{1,2}) ([0-9]{1,2}) ([0-9]{1,2})[N,S] ([0-9]{1,2}) ([0-9]{1,2}) ([0-9]{1,2})[E,W]$/i
        if (regexPattern1.test(self.locality.crdsText)){
          var match = regexPattern1.exec(self.locality.crdsText);
          self.locality.coords.longitude = match[2];
          if (self.locality.crdsText.indexOf('W') !== -1){
            self.locality.coords.longitude = (-1)*self.locality.coords.longitude;
          }
          self.locality.coords.latitude = match[1];
           if (self.locality.crdsText.indexOf('S') !== -1){
            self.locality.coords.latitude = (-1)*self.locality.coords.latitude;
          }
          self.locality.err = false;
        } else if (regexPattern2.test(self.locality.crdsText)){
          var match = regexPattern2.exec(self.locality.crdsText);
          degreeN = match[1];
          degreeE = match[4];
          minuteN = match[2];
          minuteE = match[5];
          secondN = match[3];
          secondE = match[6];
          var lat = parseFloat(degreeN) + parseFloat(minuteN)/60 + parseFloat(secondN)/3600;
          if (self.locality.crdsText.indexOf('S') !== -1){
            lat = (-1)*lat
          }
          var lon = parseFloat(degreeE) + parseFloat(minuteE)/60 + parseFloat(secondE)/3600;
          if (self.locality.crdsText.indexOf('W') !== -1){
            lon = (-1)*lon
          }
          self.locality.coords.longitude =lon;
          self.locality.coords.latitude = lat;
          self.locality.err = false;
        } else if (regexPattern3.test(self.locality.crdsText)){
          var match = regexPattern3.exec(self.locality.crdsText);
          degreeN = match[1];
          degreeE = match[3];
          minuteN = match[2];
          minuteE = match[4];
          var lat = parseFloat(degreeN) + parseFloat(minuteN)/60;
          if (self.locality.crdsText.indexOf('S') !== -1){
            lat = (-1)*lat
          }
          var lon = parseFloat(degreeE) + parseFloat(minuteE)/60;
          if (self.locality.crdsText.indexOf('W') !== -1){
            lon = (-1)*lon
          }
          self.locality.coords.longitude =lon;
          self.locality.coords.latitude = lat;
          self.locality.err = false;
        } else if (regexPattern4.test(self.locality.crdsText)){
          var match = regexPattern4.exec(self.locality.crdsText);
          degreeN = match[1];
          degreeE = match[4];
          minuteN = match[2];
          minuteE = match[5];
          secondN = match[3];
          secondE = match[6];
          var lat = parseFloat(degreeN) + parseFloat(minuteN)/60 + parseFloat(secondN)/3600;
          if (self.locality.crdsText.indexOf('S') !== -1){
            lat = (-1)*lat
          }
          var lon = parseFloat(degreeE) + parseFloat(minuteE)/60 + parseFloat(secondE)/3600;
          if (self.locality.crdsText.indexOf('E') !== -1){
            lon = (-1)*lon
          }
          self.locality.coords.longitude =(-1)*lon;
          self.locality.coords.latitude = lat;
          self.locality.err = false;
        } else if (regexPattern5.test(self.locality.crdsText)){
          var match = regexPattern5.exec(self.locality.crdsText);
          degreeN = match[1];
          degreeE = match[4];
          minuteN = match[2];
          minuteE = match[5];
          secondN = match[3];
          secondE = match[6];
          var lat = parseFloat(degreeN) + parseFloat(minuteN)/60 + parseFloat(secondN)/3600;
          if (self.locality.crdsText.indexOf('S') !== -1){
            lat = (-1)*lat
          }
          var lon = parseFloat(degreeE) + parseFloat(minuteE)/60 + parseFloat(secondE)/3600;
          if (self.locality.crdsText.indexOf('E') !== -1){
            lon = (-1)*lon
          }
          self.locality.coords.longitude =(-1)*lon;
          self.locality.coords.latitude = lat;
          self.locality.err = false;
        } else {
          alert('Zadaný formát souřadnic se nepodařilo rozpoznat');
          //self.crdsError = true;
          self.locality.err = true;
        }
        if (!self.locality.err){
          self.mapOption.lat = self.locality.coords.latitude;
          self.mapOption.lng = self.locality.coords.longitude;
          self.mapOption.zoom = 12;
        }
        $timeout(function() {
          $rootScope.$broadcast('locationUpdated');
        }, 100);
      }

      // validate
      this.validateHeader = function(){

        // validate owner
        if (!self.owner){
          alert('Uživatel musí být vyplněn');
          return false;
        }
        // validate netLength
        if (self.detail.netLength !== null && isNaN(self.detail.netLength)){
          alert('Délka sítí musí být zadána jako číslo');
          return(false);
        }
        // validate date
        if (self.date == null){           // date not set
          alert('Není vyplněno datum, nebo je v nesprávném formátu. Použijte formát "den.měsíc.rok"!');
          return(false);
        } else {
          var dt = new Date(self.date);   // date in incorrect format
          if ( Object.prototype.toString.call(dt) === "[object Date]" 
              && isNaN(dt.getTime())){
            alert('Zadané datum není ve formátu "den.měsíc.rok"!');
            return(false);
          } else {
            var today = new Date();       // date in future
            if (dt > today){
              alert('Nelze zadat datum z budoucnosti!');
              return(false);
            }
          }         
        }
        // time validation
        var timeFromValid = self.timeFrom.validate();
        var timeToValid = self.timeTo.validate();
        if (!timeFromValid){
          alert('Čas OD je zadán ve špatném formátu!');
          return(false);
        }
        if (!timeToValid){
          alert('Čas DO je zadán ve špatném formátu!');
          return(false);
        }
        // does contain :?
        if (self.timeFrom.time && self.timeFrom.time.indexOf(':') != -1){
          // does not contain ':'
          var timeFromDateText = '01/01/2011 '+  self.timeFrom.time + ':00';
        } else {
          var timeFromDateText = '01/01/2011 '+  self.timeFrom.time + ':00:00';
        }
        if (self.timeTo.time && self.timeTo.time.indexOf(':') != -1){
          // does not contain ':'
          var timeToDateText = '01/01/2011 '+  self.timeTo.time + ':00';
        } else {
          var timeToDateText = '01/01/2011 '+  self.timeTo.time + ':00:00';
        }
        if (self.timeFrom.time && self.timeTo.time){
          if ( Date.parse(timeToDateText) <  Date.parse(timeFromDateText)){
            alert('Čas DO nesmí být menší než čas OD!');
            return(false);
          }
        }
        
        
        // validate municipality
        if (self.locality.Municipality == null 
            ||typeof self.locality.Municipality === 'undefined' 
            || self.locality.Municipality.length == 0){
          alert('Obec musí být vyplněna!');
          return(false);
        }
        // validate municipality
        if (self.locality.Name == null 
            ||typeof self.locality.Name === 'undefined' 
            || self.locality.Name.length == 0){
          alert('Lokalita musí být vyplněna!');
          return(false);
        }
        // validate coordinates
        if ( self.locality.err
            || typeof self.locality.coords === 'undefined'
            || self.locality.coords == null
            || !isNumber(self.locality.coords.latitude)
            || !isNumber(self.locality.coords.longitude)){
          alert('Souřadnice musí být vyplněny a musí se jednat o čísla!');
          return(false);
        }
      }

      // save header
      this.saveHeader = function(){
        if (self.validateHeader){
          self.savingHeader = true;
            var dataToSend = {};
            // construct object to send
            dataToSend['date'] = self.date;
            dataToSend['timeFrom'] = self.timeFrom.time;
            dataToSend['timeTo'] = self.timeTo.time;
            dataToSend['note'] = self.note;
            dataToSend['owner'] = self.owner;
            dataToSend['coobservers'] = self.coobservers;
            dataToSend['locality'] = self.locality;
            dataToSend['siteSecret'] = self.siteSecret;
            dataToSend['allSecret'] = self.allSecret;
            if (self.allSecret){
              dataToSend['secretUntil'] = self.dateAllSecret;
            } else if (self.siteSecret){
              dataToSend['secretUntil'] = self.dateSiteSecret;
              dataToSend['siteSecretLevel'] = self.siteSecretLevel;
            } else {
              dataToSend['secretUntil'] = null;
            }           
            dataToSend['user'] = $rootScope.user;
            dataToSend['id'] = self.id;
            dataToSend['crdsAccuracy'] = self.detail.coordinatesAccuracy;
            dataToSend['dateAccuracy'] = self.detail.dateAccuracy;
            dataToSend['netLength'] = self.detail.netLength;
            dataToSend['placeCode'] = self.detail.placeCode;
            // send data
            observationService.sendObsList(dataToSend).then(
              function(result) {
                self.savingHeader = false;
                if (result.id){
                  self.showAlert = true;
                } else {
                  alert('Došlo k chybě, data nebyla uložena');
                }
                
              }
            );
        }
      }


      // when autocompleter option for municipality is selected, update model
      this.updateMunicipality = function (selectedValue) {
       if (selectedValue) {   
          var str = selectedValue.originalObject.obec;
          self.locality.Municipality = str.substring(0,str.indexOf('['));
          self.locality.KODCOBE = selectedValue.originalObject.KODCOBE;
          self.locality.ID_MunicipalityPart = selectedValue.originalObject.ID;
          self.detail.placeCode = selectedValue.originalObject.EuringCode;
          self.mapOption.lat = selectedValue.originalObject.latitude;
          self.mapOption.lng = selectedValue.originalObject.longitude;
          self.mapOption.zoom = 12;     
        } else {
          self.locality.Municipality = null;
          self.locality.KODCOBE = '999999';
          self.locality.ID_MunicipalityPart = null;
        }
      };

      // allow editing of header
      self.editHeader = function(){
        self.headerEdited = true;
      }

      // allow editing of detail
      self.editDetail = function(){
        self.detailEdited = true;
      }

      // delete ring item
      self.deleteItem = function(){
        var ringnumber = self.detail.ringNumber1_retrap;
        //if (self)
        if(confirm('Opravdu chcete smazat záznam kroužku '+ringnumber+'?')){
          var id = self.detail.id;
          var newringing = self.detail.ringInformation < 3;
          var station = self.detail.ringingScheme;
          var additionalUrl = '?id='+id+"&ringnumber="+ringnumber+"&ringing="+newringing+"&station="+station;
          observationService.deleteRingItem(additionalUrl).then(
            function(result) {
              if (typeof result.ok === 'undefined' || !result.ok){
                alert("Chyba, nepodařilo se smazat záznam");
              } else {
                alert('Záznam byl úspěšně smazán');
                self.cancel();
              }
            }
          );
        }
      }

      self.cancel = function(){
        self.instance.close();
      }

    }  

  }
}])
.directive('adminReports',['ringsService','codebookService','observationService','$rootScope','$filter','moment','myConfig'
  ,function(ringsService,codebookService,observationService,$rootScope,$filter,moment,myConfig){
	return {
		restrict : 'E',
		templateUrl : 'pages/admin-reports.tpl.html',
		scope : {}, 																						// isolated scope
    controllerAs : 'AdminReportCtrl',
    bindToController: true,
    controller : function ($scope){

    	// variables
    	var self = this;
    	// helpers
			self.datePicker1Opened = false;
    	self.datePicker2Opened = false;
    	self.species = null;
    	// 1st January of this year
    	self.dateFrom = new Date(new Date().getFullYear(), 0, 1,12);
    	// today
    	self.dateTo = new Date();
      self.dateFromSpec = new Date(new Date().getFullYear(), 0, 1,12);
      self.dateToSpec = new Date();
      self.minDistance = 0;
      self.minDuration = 0;
    	self.showAlert = false;
      self.showAlertSpec = false;
      self.orderColumn = '-dist';
      //self.clipboardSupported = clipboard.supported;
      self.doingResolve = false;
      // copy records
      //self.clipboardSupported = true;
      self.copiedRecords = [];
      self.copiedSpecies = null;
      self.saveFileUrl = null;
      // autocomplete
      self.scheme = $rootScope.user.rings.scheme;
      self.druhUrl = myConfig[self.scheme].druhUrl;

			// functions
      // change order of records in table
      self.changeOrderColumn = function(col){
        switch (col){
          case 'dist':
            if (self.orderColumn == '+dist'){
              self.orderColumn = '-dist';
            } else {
              self.orderColumn = '+dist';
            }
            break;
          case 'date2':
            if (self.orderColumn == '+date2'){
              self.orderColumn = '-date2';
            } else {
              self.orderColumn = '+date2';
            }
            break;
          case 'date1':
            if (self.orderColumn == '+date1'){
              self.orderColumn = '-date1';
            } else {
              self.orderColumn = '+date1';
            }
            break;
          case 'ringNumber':
            if (self.orderColumn == '+ringNumber'){
              self.orderColumn = '-ringNumber';
            } else {
              self.orderColumn = '+ringNumber';
            }
            break;
          case 'days':
            if (self.orderColumn == '+days'){
              self.orderColumn = '-days';
            } else {
              self.orderColumn = '+days';
            }
            break;
          case 'scheme':
            if (self.orderColumn == '+scheme'){
              self.orderColumn = '-scheme';
            } else {
              self.orderColumn = '+scheme';
            }
            break;
          case 'country1':
            if (self.orderColumn == '+country1'){
              self.orderColumn = '-country1';
            } else {
              self.orderColumn = '+country1';
            }
            break;
          case 'country2':
            if (self.orderColumn == '+country2'){
              self.orderColumn = '-country2';
            } else {
              self.orderColumn = '+country2';
            }
            break;
        }
      }

      // generic function to sum values in array of objects
      self.sum = function(arr,val){
        return arr.reduce( function(a, b){
          return a + b[val];
        }, 0);
      }

			self.constructSummaryUrl = function(){
				var url = '';
				url += '?dateFrom='+yyyymmdd(self.dateFrom);
				url += '&dateTo='+yyyymmdd(self.dateTo);
        url += '&scheme='+$rootScope.user.rings.scheme;
				return url;
    	}

      self.constructSpecSummaryUrl = function(){
        var url = '';
        url += '?species='+self.species.TaxonID;
        url += '&dateFrom='+yyyymmdd(self.dateFromSpec);
        url += '&dateTo='+yyyymmdd(self.dateToSpec);
        url += '&scheme='+$rootScope.user.rings.scheme;
        url += '&minDistance='+self.minDistance;
        url += '&minDuration='+self.minDuration;
        return url;
      }

			observationService.fetchSpeciesReport(self.constructSummaryUrl())
			    .then(function(data){
			    	self.totalSummary = data['totalSummary'];
			    	self.countrySummary = data['countrySummary'];
			    	self.schemesSummary = data['schemesSummary'];
			    	self.ageSummary = data['ageSummary'];
			    	self.circumstancesSummary = data['circumstancesSummary'];
			    	self.catchCountrySummary = data['catchCountrySummary'];
			    }, function(data){
			      alert("Při načítání dat došlo k chybě");
			  });

      // copy retrap summary to clipboard
      self.copyRecord = function(rec){
        rec.copied = true;
        var textToCopy = '';
        // is new species copied
        if (self.species !== self.copiedSpecies) {
          self.copiedSpecies = self.species;
          // header
          // species
          textToCopy += self.species.Fullname + '\n\n';
          // distance
          textToCopy += 'N=' + (parseInt(self.ringingDistanceSummary.S) + parseInt(self.ringingDistanceSummary.M) + parseInt(self.ringingDistanceSummary.L));
          textToCopy += ' (S ' + (self.ringingDistanceSummary.S);
          textToCopy += ', M ' + self.ringingDistanceSummary.M;
          textToCopy += ', L ' + self.ringingDistanceSummary.L + ')\n';
          // A
          textToCopy += 'A ' + self.retrapTypeSummary.A + '\n';
          // Z
          textToCopy += 'Z ' + self.retrapTypeSummary.Z + ' (';
          var i = 0
          angular.forEach(self.ringingSpeciesCountrySummary, function(item) {
            textToCopy += item.Country + ' ';        
            textToCopy += item.cnt;
            i += 1;
            if (i !== self.ringingSpeciesCountrySummary.length) {
              textToCopy += ', ';
            }
          })
          textToCopy += ')\n';
          // foreign
          textToCopy += 'C ' + self.retrapTypeSummary.C + ' (';
          i = 0
          angular.forEach(self.ringingSchemeSummary, function(item) {
            if (item.scheme2) {
              textToCopy += item.scheme2 + ' ';
            } else {
              textToCopy += 'neznámá stanice ';
            }            
            textToCopy += item.cnt;
            i += 1;
            if (i !== self.ringingSchemeSummary.length) {
              textToCopy += ', ';
            }
          })
          textToCopy += ')\n\n';
        }        

        textToCopy += rec.schemeRinging + ' ' + rec.ringNumberRinging + '\t(' + rec.ageEuring + (rec.sex === 'U' ? 'N' : rec.sex) + ')\t\t';
        if (!rec.ageEuring) {
          // if age is null, add one tab
          textToCopy += '\t';
        }
        // ringing
        if (rec.date2) {

          if (self.scheme === 'CZP') {
            textToCopy += $filter('date')(rec.date2,'dd.MM.yyyy')+'\t'
            if (rec.country2 === 'Czechia') {
              textToCopy += rec.municipality2+' ['+rec.county2+'], '
            } else {
              textToCopy += rec.region2 + ' [' + rec.country2 + '], '
            }
            if (rec.coobservers2) {
              textToCopy += rec.coobservers2;
            } else {
              textToCopy += rec.user2;
            }
            textToCopy += '\t'+$filter('crdsdeg')(rec.lat2,rec.lon2, false)+'\n';
          } else {
            // Slovakia
            textToCopy += $filter('date')(rec.date2,'dd.MM.yyyy')+'\t'
            if (rec.countyName2) {
              textToCopy += rec.countyName2 + ' [' + rec.country2 + '], '
            } else {
              textToCopy += rec.region2 + ' [' + rec.country2 + '], '
            }
            if (rec.coobservers2) {
              textToCopy += rec.coobservers2;
            } else {
              textToCopy += rec.user2;
            }
            textToCopy += '\t'+$filter('crdsdegsk')(rec.lat2,rec.lon2, false)+'\n';
          }

          
        } else {
          // ringing data missing
          textToCopy += 'data kroužkování chybí\n'
        }
         // retrap
        textToCopy += '\t\t\t\t' + $filter('date')(rec.date1,'dd.MM.yyyy') + '\t';
        // retrap in cz - town, county and user
        if (self.scheme === 'CZP') {
          if (rec.country1 === 'Czechia'){
            textToCopy += rec.municipality1+' ['+rec.county1+'], ';
            if (rec.coobservers1) {
              textToCopy += rec.coobservers1 + ' ';
            } else {
              textToCopy += rec.user1 + ' ';
            }
          } else {
            // retrap abroad - region and country
            if (rec.loc1){
              textToCopy += rec.loc1+', ';
            }
            textToCopy += rec.country1;
            if (rec.coobservers1) {
              textToCopy += ', ' + rec.coobservers1;
            }
          }
          textToCopy += '\t\t'+$filter('crdsdeg')(rec.lat1,rec.lon1, false)+'\n';
        } else {
          // slovakia
          // Slovakia
            textToCopy += $filter('date')(rec.date1,'dd.MM.yyyy')+'\t'
            if (rec.countyName1) {
              textToCopy += rec.countyName1 + ' [' + rec.country1 + '], '
            } else {
              textToCopy += rec.region1 + ' [' + rec.country1 + '], '
            }
            if (rec.coobservers1) {
              textToCopy += rec.coobservers1;
            } else {
              textToCopy += rec.user1;
            }
            textToCopy += '\t'+$filter('crdsdegsk')(rec.lat1,rec.lon1)+'\n';
        }
        // footer
        textToCopy += '\t\t\t\t\t\t';
        var dist = null;
        if (rec.dist) {
          if (self.scheme === 'CZP') {
            dist = $filter('number')(rec.dist,2);
          } else {
            dist = $filter('number')(rec.dist,0);
          }
        } else {
          dist = '--';
        }
        textToCopy += rec.circumstancesCode + '; ' + dist +' km; ';
        // duration - in miliseconds
        var dur = moment.duration(rec.days*24*60*60*1000);
        
        if (dur._data.years > 0) {
          textToCopy += dur._data.years+'r, ';  
        }
        if (dur._data.months > 0) {
          textToCopy += dur._data.months+'m, ';  
        }
        textToCopy += dur._data.days+'d';
        //clipboard.copyText(textToCopy);
        self.copiedRecords.push(textToCopy);
      }

      self.copyAll = function() {
        angular.forEach(self.speciesRecords, function (spec) {
          self.copyRecord(spec);
          spec.copied = true;
        });
      };

      self.resetCopiedRecords = function() {
        // reset copied records
        self.copiedRecords = [];
        // reset copied property for each record
        angular.forEach(self.speciesRecords, function(spec) {
          spec.copied = false;
        });
      };

      self.saveCopiedRecords = function() {
        //var content = self.copiedRecords.join('\n================\n\n');
        var content = self.copiedRecords.join('\n\n');
        var blob = new Blob([content], {encoding:"Windows-1252",type: 'plain/txt;charset=Windows-1252'}),
          e = document.createEvent('MouseEvents'),
          a = document.createElement('a');
        a.download = 'report.txt';
        a.href = window.URL.createObjectURL(blob);
        a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
        e.initEvent('click', true, false, window,
            0, 0, 0, 0, 0, false, false, false, false, 0, null);
        a.dispatchEvent(e);
      }
		
    	// open datepicker
    	self.openDatePicker = function(val){
		  	 if (val == 1){
		  	 	self.datePicker1Opened = true;
		  	 } else if (val == 2){
		  	 	self.datePicker2Opened = true;
		  	 }
		  }

      // open datepicker
      self.openDatePickerSpec = function(val){
         if (val == 1){
          self.datePicker3Opened = true;
         } else if (val == 2){
          self.datePicker4Opened = true;
         }
      }

    	// when autocompleter option for species is selected, update model
    	this.updateSpecies = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
          self.species = null;
          return;
        }
        self.species = selectedValue.originalObject; 
    	};
    	
    	// report - species
			self.getReport = function(){
			  observationService.fetchSpeciesReport(self.constructSummaryUrl())
			    .then(function(data){
			    	self.totalSummary = data['totalSummary'];
			    	self.countrySummary = data['countrySummary'];
			    	self.schemesSummary = data['schemesSummary'];
			    	self.ageSummary = data['ageSummary'];
			    	self.circumstancesSummary = data['circumstancesSummary'];
			    	self.catchCountrySummary = data['catchCountrySummary'];
			    }, function(data){
			      alert("Při načítání dat došlo k chybě");
			  });
		  }

      // report - species
      self.getReportSpec = function(){
        self.doingResolve = true;
        observationService.fetchSpeciesReport(self.constructSpecSummaryUrl())
          .then(function(data){
            self.ringingSchemeSummary = data['ringingSchemeSummary'];
            self.ringingSpeciesCountrySummary = data['ringingSpeciesCountrySummary'];
            self.ringingDistanceSummary = {
              S: 0,
              M: 0,
              L: 0
            };
            angular.forEach(data['ringingDistanceSummary'], function(item) {
              switch (item.cat) {
                case 'S':
                  self.ringingDistanceSummary.S = item.cnt;
                  break;
                case 'L':
                  self.ringingDistanceSummary.L = item.cnt;
                  break;
                case 'M':
                  self.ringingDistanceSummary.M = item.cnt;
                  break;
              }
            })
            //self.ringingDistanceSummary = data['ringingDistanceSummary'];
            self.speciesRecords = data['speciesRecords'];
            self.retrapTypeSummary = {
              A: 0,
              C: 0,
              Z: 0,
              U: 0,
              X: 0
            }
            for (var i=0;i<data.retrapTypeSummary.length;i++){
              self.retrapTypeSummary[data.retrapTypeSummary[i].ID_RetrapType] = data.retrapTypeSummary[i].cnt
            }
            self.doingResolve = false;
          }, function(data){
            alert("Při načítání dat došlo k chybě");
        });
      }

    }
	}
}	])
.directive('euringExport',['exportService','$interval','myConfig','$rootScope'
  ,function(exportService,$interval,myConfig,$rootScope){
  return {
    restrict : 'E',
    templateUrl : 'pages/euring-export.tpl.html',
    scope : {},                                             // isolated scope
    controllerAs : 'EuringExportCtrl',
    bindToController: true,
    controller : function ($scope){

      // variables
      var self = this;
      // helpers
      self.showProgress = false;
      self.showDownloadLinks = false;
      self.progressBarActive = false;
      self.statusText = 'připraveno';
      self.ringingDone =  false;
      self.retrapDone =  false;
      self.dateRinging = null;
      self.dateRetrap = null;
      self.doingResolve = false;

      //self.ringingUrl = myConfig.apiUrl.replace('v1/','userdata/rings/export/ringing.dat');
      //self.retrapUrl = myConfig.apiUrl.replace('v1/','userdata/rings/export/retrap.dat');

      self.scheme = $rootScope.user.rings.scheme;
      self.suffix = self.scheme === 'CZP' ? '' : '_sk';

      self.originalDates = {
        ringing: null,
        retrap: null
      };

      self.updateExportStatus = function() {
        exportService.getEuringStatus(self.scheme)
          .then(function(data){
            var newDates = {
              ringing: new Date(data.ringing),
              retrap: new Date(data.retrap)
            }
            if (self.originalDates.ringing === null){
              self.statusText = 'kontroluji';
              self.originalDates = newDates;
            } else {
              if (angular.equals(self.originalDates, newDates)){
                self.statusText = 'soubory vygenerovány';
                self.showDownloadLinks = true;
                self.progressBarActive = false;
                if (angular.isDefined(checker)) {
                  $interval.cancel(checker);
                  checker = undefined;
                }
              } else {
                self.statusText = 'soubory se generují';
                self.originalDates = newDates;
              }              
            }
          })
      }

      self.showExportStatus = function() {
        self.showProgress =  true;
        self.progressBarActive = true;
        self.statusText = 'odesílám požadavek';
        checker = $interval(self.updateExportStatus,5000)
      }

      self.generateExportFiles = function(){
        self.doingResolve = true;
        self.showDownloadLinks = false;
        exportService.generateEuring(self.scheme)
          .then(function(data){
            self.doingResolve = false;
            self.showExportStatus(self.scheme);
          });        
      }

    }
  }
} ])
;